import _typeof2 from "@babel/runtime-corejs3/helpers/typeof";

var _context18, _context19, _context22;

import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _Symbol$iterator from "@babel/runtime-corejs3/core-js-stable/symbol/iterator";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$create from "@babel/runtime-corejs3/core-js-stable/object/create";
import _Object$getOwnPropertyNames from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-names";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getPrototypeOf from "@babel/runtime-corejs3/core-js-stable/object/get-prototype-of";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/keys";
import _Object$setPrototypeOf from "@babel/runtime-corejs3/core-js-stable/object/set-prototype-of";
import _entriesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/entries";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _lastIndexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/last-index-of";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
var commonjsGlobal$1 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}

function createCommonjsModule$1(fn, module) {
  return fn(module = {
    exports: {}
  }, module.exports), module.exports;
}

var check = function check(it) {
  return it && it.Math == Math && it;
},
    global_1 = check("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof2(globalThis)) && globalThis) || check("object" == (typeof window === "undefined" ? "undefined" : _typeof2(window)) && window) || check("object" == (typeof self === "undefined" ? "undefined" : _typeof2(self)) && self) || check("object" == _typeof2(commonjsGlobal$1) && commonjsGlobal$1) || function () {
  return this;
}() || Function("return this")(),
    fails = function fails(exec) {
  try {
    return !!exec();
  } catch (error) {
    return !0;
  }
},
    descriptors = !fails(function () {
  return 7 != _Object$defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1];
}),
    $propertyIsEnumerable$1 = {}.propertyIsEnumerable,
    getOwnPropertyDescriptor$2 = _Object$getOwnPropertyDescriptor,
    NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable$1.call({
  1: 2
}, 1),
    f$7 = NASHORN_BUG ? function (V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$1,
    objectPropertyIsEnumerable = {
  f: f$7
},
    createPropertyDescriptor = function createPropertyDescriptor(bitmap, value) {
  return {
    enumerable: !(1 & bitmap),
    configurable: !(2 & bitmap),
    writable: !(4 & bitmap),
    value: value
  };
},
    toString$1 = {}.toString,
    classofRaw = function classofRaw(it) {
  var _context7;

  return _sliceInstanceProperty(_context7 = toString$1.call(it)).call(_context7, 8, -1);
},
    split = "".split,
    indexedObject = fails(function () {
  return !Object("z").propertyIsEnumerable(0);
}) ? function (it) {
  return "String" == classofRaw(it) ? split.call(it, "") : Object(it);
} : Object,
    requireObjectCoercible = function requireObjectCoercible(it) {
  if (null == it) throw TypeError("Can't call method on " + it);
  return it;
},
    toIndexedObject = function toIndexedObject(it) {
  return indexedObject(requireObjectCoercible(it));
},
    isObject = function isObject(it) {
  return "object" == _typeof2(it) ? null !== it : "function" == typeof it;
},
    toPrimitive = function toPrimitive(input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && "function" == typeof (fn = input.toString) && !isObject(val = fn.call(input))) return val;
  if ("function" == typeof (fn = input.valueOf) && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && "function" == typeof (fn = input.toString) && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
},
    toObject = function toObject(argument) {
  return Object(requireObjectCoercible(argument));
},
    hasOwnProperty = {}.hasOwnProperty,
    has$1 = Object.hasOwn || function (it, key) {
  return hasOwnProperty.call(toObject(it), key);
},
    document$3 = global_1.document,
    EXISTS = isObject(document$3) && isObject(document$3.createElement),
    documentCreateElement = function documentCreateElement(it) {
  return EXISTS ? document$3.createElement(it) : {};
},
    ie8DomDefine = !descriptors && !fails(function () {
  return 7 != _Object$defineProperty(documentCreateElement("div"), "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    $getOwnPropertyDescriptor$1 = _Object$getOwnPropertyDescriptor,
    f$6 = descriptors ? $getOwnPropertyDescriptor$1 : function (O, P) {
  if (O = toIndexedObject(O), P = toPrimitive(P, !0), ie8DomDefine) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) {}
  if (has$1(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
},
    objectGetOwnPropertyDescriptor = {
  f: f$6
},
    replacement = /#|\.prototype\./,
    isForced = function isForced(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL || value != NATIVE && ("function" == typeof detection ? fails(detection) : !!detection);
},
    normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, ".").toLowerCase();
},
    data = isForced.data = {},
    NATIVE = isForced.NATIVE = "N",
    POLYFILL = isForced.POLYFILL = "P",
    isForced_1 = isForced,
    path = {},
    aFunction$1 = function aFunction$1(it) {
  if ("function" != typeof it) throw TypeError(String(it) + " is not a function");
  return it;
},
    functionBindContext = function functionBindContext(fn, that, length) {
  if (aFunction$1(fn), void 0 === that) return fn;

  switch (length) {
    case 0:
      return function () {
        return fn.call(that);
      };

    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function () {
    return fn.apply(that, arguments);
  };
},
    anObject = function anObject(it) {
  if (!isObject(it)) throw TypeError(String(it) + " is not an object");
  return it;
},
    $defineProperty$1 = _Object$defineProperty,
    f$5 = descriptors ? $defineProperty$1 : function (O, P, Attributes) {
  if (anObject(O), P = toPrimitive(P, !0), anObject(Attributes), ie8DomDefine) try {
    return $defineProperty$1(O, P, Attributes);
  } catch (error) {}
  if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
  return "value" in Attributes && (O[P] = Attributes.value), O;
},
    objectDefineProperty = {
  f: f$5
},
    createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  return object[key] = value, object;
},
    getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f,
    wrapConstructor = function wrapConstructor(NativeConstructor) {
  var Wrapper = function Wrapper(a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0:
          return new NativeConstructor();

        case 1:
          return new NativeConstructor(a);

        case 2:
          return new NativeConstructor(a, b);
      }

      return new NativeConstructor(a, b, c);
    }

    return NativeConstructor.apply(this, arguments);
  };

  return Wrapper.prototype = NativeConstructor.prototype, Wrapper;
},
    _export = function _export(options, source) {
  var USE_NATIVE,
      VIRTUAL_PROTOTYPE,
      key,
      sourceProperty,
      targetProperty,
      nativeProperty,
      resultProperty,
      descriptor,
      TARGET = options.target,
      GLOBAL = options.global,
      STATIC = options.stat,
      PROTO = options.proto,
      nativeSource = GLOBAL ? global_1 : STATIC ? global_1[TARGET] : (global_1[TARGET] || {}).prototype,
      target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {}),
      targetPrototype = target.prototype;

  for (key in source) {
    USE_NATIVE = !isForced_1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced) && nativeSource && has$1(nativeSource, key), targetProperty = target[key], USE_NATIVE && (nativeProperty = options.noTargetGet ? (descriptor = getOwnPropertyDescriptor$1(nativeSource, key)) && descriptor.value : nativeSource[key]), sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key], USE_NATIVE && _typeof2(targetProperty) == _typeof2(sourceProperty) || (resultProperty = _bindInstanceProperty(options) && USE_NATIVE ? functionBindContext(sourceProperty, global_1) : options.wrap && USE_NATIVE ? wrapConstructor(sourceProperty) : PROTO && "function" == typeof sourceProperty ? functionBindContext(Function.call, sourceProperty) : sourceProperty, (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) && createNonEnumerableProperty(resultProperty, "sham", !0), target[key] = resultProperty, PROTO && (has$1(path, VIRTUAL_PROTOTYPE = TARGET + "Prototype") || createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {}), path[VIRTUAL_PROTOTYPE][key] = sourceProperty, options.real && targetPrototype && !targetPrototype[key] && createNonEnumerableProperty(targetPrototype, key, sourceProperty)));
  }
},
    isArray$3 = _Array$isArray || function (arg) {
  return "Array" == classofRaw(arg);
},
    ceil = Math.ceil,
    floor = Math.floor,
    toInteger = function toInteger(argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
},
    min$3 = Math.min,
    toLength = function toLength(argument) {
  return argument > 0 ? min$3(toInteger(argument), 9007199254740991) : 0;
},
    createProperty = function createProperty(object, key, value) {
  var propertyKey = toPrimitive(key);
  propertyKey in object ? objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value)) : object[propertyKey] = value;
},
    isPure = !0,
    setGlobal = function setGlobal(key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  }

  return value;
},
    SHARED = "__core-js_shared__",
    store$1 = global_1[SHARED] || setGlobal(SHARED, {}),
    sharedStore = store$1,
    shared = createCommonjsModule$1(function (module) {
  (module.exports = function (key, value) {
    return sharedStore[key] || (sharedStore[key] = void 0 !== value ? value : {});
  })("versions", []).push({
    version: "3.15.2",
    mode: "pure",
    copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
  });
}),
    id = 0,
    postfix = Math.random(),
    uid = function uid(key) {
  return "Symbol(" + String(void 0 === key ? "" : key) + ")_" + (++id + postfix).toString(36);
},
    aFunction = function aFunction(variable) {
  return "function" == typeof variable ? variable : void 0;
},
    getBuiltIn = function getBuiltIn(namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace]) : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
},
    engineUserAgent = getBuiltIn("navigator", "userAgent") || "",
    process$4 = global_1.process,
    versions = process$4 && process$4.versions,
    v8 = versions && versions.v8,
    match,
    version$1;

v8 ? (match = v8.split("."), version$1 = match[0] < 4 ? 1 : match[0] + match[1]) : engineUserAgent && (match = engineUserAgent.match(/Edge\/(\d+)/), (!match || match[1] >= 74) && (match = engineUserAgent.match(/Chrome\/(\d+)/), match && (version$1 = match[1])));

var engineV8Version = version$1 && +version$1,
    nativeSymbol = !!_Object$getOwnPropertySymbols && !fails(function () {
  var symbol = _Symbol();

  return !String(symbol) || !(Object(symbol) instanceof _Symbol) || !_Symbol.sham && engineV8Version && engineV8Version < 41;
}),
    useSymbolAsUid = nativeSymbol && !_Symbol.sham && "symbol" == _typeof2(_Symbol$iterator),
    WellKnownSymbolsStore$1 = shared("wks"),
    Symbol$1 = global_1.Symbol,
    createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid,
    wellKnownSymbol = function wellKnownSymbol(name) {
  return has$1(WellKnownSymbolsStore$1, name) && (nativeSymbol || "string" == typeof WellKnownSymbolsStore$1[name]) || (nativeSymbol && has$1(Symbol$1, name) ? WellKnownSymbolsStore$1[name] = Symbol$1[name] : WellKnownSymbolsStore$1[name] = createWellKnownSymbol("Symbol." + name)), WellKnownSymbolsStore$1[name];
},
    SPECIES$5 = wellKnownSymbol("species"),
    arraySpeciesCreate = function arraySpeciesCreate(originalArray, length) {
  var C;
  return isArray$3(originalArray) && ("function" != typeof (C = originalArray.constructor) || C !== Array && !isArray$3(C.prototype) ? isObject(C) && null === (C = C[SPECIES$5]) && (C = void 0) : C = void 0), new (void 0 === C ? Array : C)(0 === length ? 0 : length);
},
    SPECIES$4 = wellKnownSymbol("species"),
    arrayMethodHasSpeciesSupport = function arrayMethodHasSpeciesSupport(METHOD_NAME) {
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    return (array.constructor = {})[SPECIES$4] = function () {
      return {
        foo: 1
      };
    }, 1 !== array[METHOD_NAME](Boolean).foo;
  });
},
    IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable"),
    MAX_SAFE_INTEGER = 9007199254740991,
    MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded",
    IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  return array[IS_CONCAT_SPREADABLE] = !1, _concatInstanceProperty(array).call(array)[0] !== array;
}),
    SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat"),
    isConcatSpreadable = function isConcatSpreadable(O) {
  if (!isObject(O)) return !1;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return void 0 !== spreadable ? !!spreadable : isArray$3(O);
},
    FORCED$3 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

_export({
  target: "Array",
  proto: !0,
  forced: FORCED$3
}, {
  concat: function concat(arg) {
    var i,
        k,
        length,
        len,
        E,
        O = toObject(this),
        A = arraySpeciesCreate(O, 0),
        n = 0;

    for (i = -1, length = arguments.length; i < length; i++) {
      if (isConcatSpreadable(E = -1 === i ? O : arguments[i])) {
        if (n + (len = toLength(E.length)) > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

        for (k = 0; k < len; k++, n++) {
          k in E && createProperty(A, n, E[k]);
        }
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }

    return A.length = n, A;
  }
});

var max$1 = Math.max,
    min$2 = Math.min,
    toAbsoluteIndex = function toAbsoluteIndex(index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
},
    createMethod$2 = function createMethod$2(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var value,
        O = toIndexedObject($this),
        length = toLength(O.length),
        index = toAbsoluteIndex(fromIndex, length);

    if (IS_INCLUDES && el != el) {
      for (; length > index;) {
        if ((value = O[index++]) != value) return !0;
      }
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }

    return !IS_INCLUDES && -1;
  };
},
    arrayIncludes = {
  includes: createMethod$2(!0),
  indexOf: createMethod$2(!1)
},
    hiddenKeys$1 = {},
    indexOf$3 = _indexOfInstanceProperty(arrayIncludes),
    objectKeysInternal = function objectKeysInternal(object, names) {
  var key,
      O = toIndexedObject(object),
      i = 0,
      result = [];

  for (key in O) {
    !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key);
  }

  for (; names.length > i;) {
    has$1(O, key = names[i++]) && (~indexOf$3(result, key) || result.push(key));
  }

  return result;
},
    enumBugKeys = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    objectKeys = _Object$keys || function (O) {
  return objectKeysInternal(O, enumBugKeys);
},
    objectDefineProperties = descriptors ? _Object$defineProperties : function (O, Properties) {
  anObject(O);

  for (var key, keys = objectKeys(Properties), length = keys.length, index = 0; length > index;) {
    objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  }

  return O;
},
    html = getBuiltIn("document", "documentElement"),
    keys$3 = shared("keys"),
    sharedKey = function sharedKey(key) {
  return keys$3[key] || (keys$3[key] = uid(key));
},
    GT = ">",
    LT = "<",
    PROTOTYPE$1 = "prototype",
    SCRIPT = "script",
    IE_PROTO$1 = sharedKey("IE_PROTO"),
    EmptyConstructor = function EmptyConstructor() {},
    scriptTag = function scriptTag(content) {
  return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
},
    NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
  activeXDocument.write(scriptTag("")), activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  return activeXDocument = null, temp;
},
    NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
  var iframeDocument,
      iframe = documentCreateElement("iframe"),
      JS = "java" + SCRIPT + ":";
  return iframe.style.display = "none", html.appendChild(iframe), iframe.src = String(JS), (iframeDocument = iframe.contentWindow.document).open(), iframeDocument.write(scriptTag("document.F=Object")), iframeDocument.close(), iframeDocument.F;
},
    activeXDocument,
    _NullProtoObject = function NullProtoObject() {
  try {
    activeXDocument = document.domain && new ActiveXObject("htmlfile");
  } catch (error) {}

  _NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();

  for (var length = enumBugKeys.length; length--;) {
    delete _NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];
  }

  return _NullProtoObject();
};

hiddenKeys$1[IE_PROTO$1] = !0;

var objectCreate = _Object$create || function (O, Properties) {
  var result;
  return null !== O ? (EmptyConstructor[PROTOTYPE$1] = anObject(O), result = new EmptyConstructor(), EmptyConstructor[PROTOTYPE$1] = null, result[IE_PROTO$1] = O) : result = _NullProtoObject(), void 0 === Properties ? result : objectDefineProperties(result, Properties);
},
    hiddenKeys = _concatInstanceProperty(enumBugKeys).call(enumBugKeys, "length", "prototype"),
    f$4 = _Object$getOwnPropertyNames || function (O) {
  return objectKeysInternal(O, hiddenKeys);
},
    objectGetOwnPropertyNames = {
  f: f$4
},
    $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f,
    toString = {}.toString,
    windowNames = "object" == (typeof window === "undefined" ? "undefined" : _typeof2(window)) && window && _Object$getOwnPropertyNames ? _Object$getOwnPropertyNames(window) : [],
    getWindowNames = function getWindowNames(it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error) {
    return _sliceInstanceProperty(windowNames).call(windowNames);
  }
},
    f$3 = function f$3(it) {
  return windowNames && "[object Window]" == toString.call(it) ? getWindowNames(it) : $getOwnPropertyNames$1(toIndexedObject(it));
},
    objectGetOwnPropertyNamesExternal = {
  f: f$3
},
    f$2 = _Object$getOwnPropertySymbols,
    objectGetOwnPropertySymbols = {
  f: f$2
},
    redefine = function redefine(target, key, value, options) {
  options && options.enumerable ? target[key] = value : createNonEnumerableProperty(target, key, value);
},
    f$1 = wellKnownSymbol,
    wellKnownSymbolWrapped = {
  f: f$1
},
    defineProperty$6 = objectDefineProperty.f,
    defineWellKnownSymbol = function defineWellKnownSymbol(NAME) {
  var _Symbol2 = path.Symbol || (path.Symbol = {});

  has$1(_Symbol2, NAME) || defineProperty$6(_Symbol2, NAME, {
    value: wellKnownSymbolWrapped.f(NAME)
  });
},
    TO_STRING_TAG$3 = wellKnownSymbol("toStringTag"),
    test = {};

test[TO_STRING_TAG$3] = "z";

var toStringTagSupport = "[object z]" === String(test),
    TO_STRING_TAG$2 = wellKnownSymbol("toStringTag"),
    CORRECT_ARGUMENTS = "Arguments" == classofRaw(function () {
  return arguments;
}()),
    tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (error) {}
},
    classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return void 0 === it ? "Undefined" : null === it ? "Null" : "string" == typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$2)) ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : "Object" == (result = classofRaw(O)) && "function" == typeof O.callee ? "Arguments" : result;
},
    objectToString = toStringTagSupport ? {}.toString : function () {
  return "[object " + classof(this) + "]";
},
    defineProperty$5 = objectDefineProperty.f,
    TO_STRING_TAG$1 = wellKnownSymbol("toStringTag"),
    setToStringTag = function setToStringTag(it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    has$1(target, TO_STRING_TAG$1) || defineProperty$5(target, TO_STRING_TAG$1, {
      configurable: !0,
      value: TAG
    }), SET_METHOD && !toStringTagSupport && createNonEnumerableProperty(target, "toString", objectToString);
  }
},
    functionToString = Function.toString;

"function" != typeof sharedStore.inspectSource && (sharedStore.inspectSource = function (it) {
  return functionToString.call(it);
});

var inspectSource = sharedStore.inspectSource,
    WeakMap$1 = global_1.WeakMap,
    nativeWeakMap = "function" == typeof WeakMap$1 && /native code/.test(inspectSource(WeakMap$1)),
    OBJECT_ALREADY_INITIALIZED = "Object already initialized",
    WeakMap = global_1.WeakMap,
    set$1,
    get,
    has,
    enforce = function enforce(it) {
  return has(it) ? get(it) : set$1(it, {});
},
    getterFor = function getterFor(TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
    return state;
  };
};

if (nativeWeakMap || sharedStore.state) {
  var store = sharedStore.state || (sharedStore.state = new WeakMap()),
      wmget = store.get,
      wmhas = store.has,
      wmset = store.set;
  set$1 = function set$1(it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    return metadata.facade = it, wmset.call(store, it, metadata), metadata;
  }, get = function get(it) {
    return wmget.call(store, it) || {};
  }, has = function has(it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey("state");
  hiddenKeys$1[STATE] = !0, set$1 = function set$1(it, metadata) {
    if (has$1(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    return metadata.facade = it, createNonEnumerableProperty(it, STATE, metadata), metadata;
  }, get = function get(it) {
    return has$1(it, STATE) ? it[STATE] : {};
  }, has = function has(it) {
    return has$1(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
},
    push = [].push,
    createMethod$1 = function createMethod$1(TYPE) {
  var IS_MAP = 1 == TYPE,
      IS_FILTER = 2 == TYPE,
      IS_SOME = 3 == TYPE,
      IS_EVERY = 4 == TYPE,
      IS_FIND_INDEX = 6 == TYPE,
      IS_FILTER_OUT = 7 == TYPE,
      NO_HOLES = 5 == TYPE || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    for (var value, result, O = toObject($this), self = indexedObject(O), boundFunction = functionBindContext(callbackfn, that, 3), length = toLength(self.length), index = 0, create = specificCreate || arraySpeciesCreate, target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : void 0; length > index; index++) {
      if ((NO_HOLES || index in self) && (result = boundFunction(value = self[index], index, O), TYPE)) if (IS_MAP) target[index] = result;else if (result) switch (TYPE) {
        case 3:
          return !0;

        case 5:
          return value;

        case 6:
          return index;

        case 2:
          push.call(target, value);
      } else switch (TYPE) {
        case 4:
          return !1;

        case 7:
          push.call(target, value);
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
},
    arrayIteration = {
  forEach: createMethod$1(0),
  map: createMethod$1(1),
  filter: createMethod$1(2),
  some: createMethod$1(3),
  every: createMethod$1(4),
  find: createMethod$1(5),
  findIndex: createMethod$1(6),
  filterOut: createMethod$1(7)
},
    $forEach$1 = _forEachInstanceProperty(arrayIteration),
    HIDDEN = sharedKey("hidden"),
    SYMBOL = "Symbol",
    PROTOTYPE = "prototype",
    TO_PRIMITIVE = wellKnownSymbol("toPrimitive"),
    setInternalState$3 = internalState.set,
    getInternalState$3 = internalState.getterFor(SYMBOL),
    ObjectPrototype$1 = Object[PROTOTYPE],
    _$Symbol = global_1.Symbol,
    $stringify$1 = getBuiltIn("JSON", "stringify"),
    nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f,
    nativeDefineProperty = objectDefineProperty.f,
    nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f,
    nativePropertyIsEnumerable = objectPropertyIsEnumerable.f,
    AllSymbols = shared("symbols"),
    ObjectPrototypeSymbols = shared("op-symbols"),
    StringToSymbolRegistry = shared("string-to-symbol-registry"),
    SymbolToStringRegistry = shared("symbol-to-string-registry"),
    WellKnownSymbolsStore = shared("wks"),
    QObject = global_1.QObject,
    USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild,
    setSymbolDescriptor = descriptors && fails(function () {
  return 7 != objectCreate(nativeDefineProperty({}, "a", {
    get: function get() {
      return nativeDefineProperty(this, "a", {
        value: 7
      }).a;
    }
  })).a;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype$1, P);
  ObjectPrototypeDescriptor && delete ObjectPrototype$1[P], nativeDefineProperty(O, P, Attributes), ObjectPrototypeDescriptor && O !== ObjectPrototype$1 && nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
} : nativeDefineProperty,
    wrap = function wrap(tag, description) {
  var symbol = AllSymbols[tag] = objectCreate(_$Symbol[PROTOTYPE]);
  return setInternalState$3(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  }), descriptors || (symbol.description = description), symbol;
},
    isSymbol = useSymbolAsUid ? function (it) {
  return "symbol" == _typeof2(it);
} : function (it) {
  return Object(it) instanceof _$Symbol;
},
    $defineProperty = function $defineProperty(O, P, Attributes) {
  O === ObjectPrototype$1 && $defineProperty(ObjectPrototypeSymbols, P, Attributes), anObject(O);
  var key = toPrimitive(P, !0);
  return anObject(Attributes), has$1(AllSymbols, key) ? (Attributes.enumerable ? (has$1(O, HIDDEN) && O[HIDDEN][key] && (O[HIDDEN][key] = !1), Attributes = objectCreate(Attributes, {
    enumerable: createPropertyDescriptor(0, !1)
  })) : (has$1(O, HIDDEN) || nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {})), O[HIDDEN][key] = !0), setSymbolDescriptor(O, key, Attributes)) : nativeDefineProperty(O, key, Attributes);
},
    $defineProperties = function $defineProperties(O, Properties) {
  var _context17;

  anObject(O);

  var properties = toIndexedObject(Properties),
      keys = _concatInstanceProperty(_context17 = objectKeys(properties)).call(_context17, $getOwnPropertySymbols(properties));

  return $forEach$1(keys, function (key) {
    descriptors && !$propertyIsEnumerable.call(properties, key) || $defineProperty(O, key, properties[key]);
  }), O;
},
    $create = function $create(O, Properties) {
  return void 0 === Properties ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
},
    $propertyIsEnumerable = function $propertyIsEnumerable(V) {
  var P = toPrimitive(V, !0),
      enumerable = nativePropertyIsEnumerable.call(this, P);
  return !(this === ObjectPrototype$1 && has$1(AllSymbols, P) && !has$1(ObjectPrototypeSymbols, P)) && (!(enumerable || !has$1(this, P) || !has$1(AllSymbols, P) || has$1(this, HIDDEN) && this[HIDDEN][P]) || enumerable);
},
    $getOwnPropertyDescriptor = function $getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O),
      key = toPrimitive(P, !0);

  if (it !== ObjectPrototype$1 || !has$1(AllSymbols, key) || has$1(ObjectPrototypeSymbols, key)) {
    var descriptor = nativeGetOwnPropertyDescriptor(it, key);
    return !descriptor || !has$1(AllSymbols, key) || has$1(it, HIDDEN) && it[HIDDEN][key] || (descriptor.enumerable = !0), descriptor;
  }
},
    $getOwnPropertyNames = function $getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O)),
      result = [];
  return $forEach$1(names, function (key) {
    has$1(AllSymbols, key) || has$1(hiddenKeys$1, key) || result.push(key);
  }), result;
},
    $getOwnPropertySymbols = function $getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1,
      names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O)),
      result = [];
  return $forEach$1(names, function (key) {
    !has$1(AllSymbols, key) || IS_OBJECT_PROTOTYPE && !has$1(ObjectPrototype$1, key) || result.push(AllSymbols[key]);
  }), result;
};

if (nativeSymbol || (_$Symbol = function $Symbol() {
  if (this instanceof _$Symbol) throw TypeError("Symbol is not a constructor");

  var description = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
      tag = uid(description),
      setter = function setter(value) {
    this === ObjectPrototype$1 && setter.call(ObjectPrototypeSymbols, value), has$1(this, HIDDEN) && has$1(this[HIDDEN], tag) && (this[HIDDEN][tag] = !1), setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
  };

  return descriptors && USE_SETTER && setSymbolDescriptor(ObjectPrototype$1, tag, {
    configurable: !0,
    set: setter
  }), wrap(tag, description);
}, redefine(_$Symbol[PROTOTYPE], "toString", function () {
  return getInternalState$3(this).tag;
}), redefine(_$Symbol, "withoutSetter", function (description) {
  return wrap(uid(description), description);
}), objectPropertyIsEnumerable.f = $propertyIsEnumerable, objectDefineProperty.f = $defineProperty, objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor, objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames, objectGetOwnPropertySymbols.f = $getOwnPropertySymbols, wellKnownSymbolWrapped.f = function (name) {
  return wrap(wellKnownSymbol(name), name);
}, descriptors && nativeDefineProperty(_$Symbol[PROTOTYPE], "description", {
  configurable: !0,
  get: function get() {
    return getInternalState$3(this).description;
  }
})), _export({
  global: !0,
  wrap: !0,
  forced: !nativeSymbol,
  sham: !nativeSymbol
}, {
  Symbol: _$Symbol
}), $forEach$1(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
}), _export({
  target: SYMBOL,
  stat: !0,
  forced: !nativeSymbol
}, {
  "for": function _for(key) {
    var string = String(key);
    if (has$1(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];

    var symbol = _$Symbol(string);

    return StringToSymbolRegistry[string] = symbol, SymbolToStringRegistry[symbol] = string, symbol;
  },
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol");
    if (has$1(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function useSetter() {
    USE_SETTER = !0;
  },
  useSimple: function useSimple() {
    USE_SETTER = !1;
  }
}), _export({
  target: "Object",
  stat: !0,
  forced: !nativeSymbol,
  sham: !descriptors
}, {
  create: $create,
  defineProperty: $defineProperty,
  defineProperties: $defineProperties,
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
}), _export({
  target: "Object",
  stat: !0,
  forced: !nativeSymbol
}, {
  getOwnPropertyNames: $getOwnPropertyNames,
  getOwnPropertySymbols: $getOwnPropertySymbols
}), _export({
  target: "Object",
  stat: !0,
  forced: fails(function () {
    objectGetOwnPropertySymbols.f(1);
  })
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols.f(toObject(it));
  }
}), $stringify$1) {
  var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
    var symbol = _$Symbol();

    return "[null]" != $stringify$1([symbol]) || "{}" != $stringify$1({
      a: symbol
    }) || "{}" != $stringify$1(Object(symbol));
  });

  _export({
    target: "JSON",
    stat: !0,
    forced: FORCED_JSON_STRINGIFY
  }, {
    stringify: function stringify(it, replacer, space) {
      for (var $replacer, args = [it], index = 1; arguments.length > index;) {
        args.push(arguments[index++]);
      }

      if ($replacer = replacer, (isObject(replacer) || void 0 !== it) && !isSymbol(it)) return isArray$3(replacer) || (replacer = function replacer(key, value) {
        if ("function" == typeof $replacer && (value = $replacer.call(this, key, value)), !isSymbol(value)) return value;
      }), args[1] = replacer, $stringify$1.apply(null, args);
    }
  });
}

_$Symbol[PROTOTYPE][TO_PRIMITIVE] || createNonEnumerableProperty(_$Symbol[PROTOTYPE], TO_PRIMITIVE, _$Symbol[PROTOTYPE].valueOf), setToStringTag(_$Symbol, SYMBOL), hiddenKeys$1[HIDDEN] = !0, defineWellKnownSymbol("asyncIterator"), defineWellKnownSymbol("hasInstance"), defineWellKnownSymbol("isConcatSpreadable"), defineWellKnownSymbol("iterator"), defineWellKnownSymbol("match"), defineWellKnownSymbol("matchAll"), defineWellKnownSymbol("replace"), defineWellKnownSymbol("search"), defineWellKnownSymbol("species"), defineWellKnownSymbol("split"), defineWellKnownSymbol("toPrimitive"), defineWellKnownSymbol("toStringTag"), defineWellKnownSymbol("unscopables"), setToStringTag(global_1.JSON, "JSON", !0);
var symbol$2 = path.Symbol;
defineWellKnownSymbol("asyncDispose"), defineWellKnownSymbol("dispose"), defineWellKnownSymbol("matcher"), defineWellKnownSymbol("metadata"), defineWellKnownSymbol("observable"), defineWellKnownSymbol("patternMatch"), defineWellKnownSymbol("replaceAll");

var symbol$1 = symbol$2,
    symbol = symbol$1,
    createMethod = function createMethod(CONVERT_TO_STRING) {
  return function ($this, pos) {
    var first,
        second,
        S = String(requireObjectCoercible($this)),
        position = toInteger(pos),
        size = S.length;
    return position < 0 || position >= size ? CONVERT_TO_STRING ? "" : void 0 : (first = S.charCodeAt(position)) < 55296 || first > 56319 || position + 1 === size || (second = S.charCodeAt(position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? _sliceInstanceProperty(S).call(S, position, position + 2) : second - 56320 + (first - 55296 << 10) + 65536;
  };
},
    stringMultibyte = {
  codeAt: createMethod(!1),
  charAt: createMethod(!0)
},
    correctPrototypeGetter = !fails(function () {
  function F() {}

  return F.prototype.constructor = null, _Object$getPrototypeOf(new F()) !== F.prototype;
}),
    IE_PROTO = sharedKey("IE_PROTO"),
    ObjectPrototype = Object.prototype,
    objectGetPrototypeOf = correctPrototypeGetter ? _Object$getPrototypeOf : function (O) {
  return O = toObject(O), has$1(O, IE_PROTO) ? O[IE_PROTO] : "function" == typeof O.constructor && O instanceof O.constructor ? O.constructor.prototype : O instanceof Object ? ObjectPrototype : null;
},
    ITERATOR$4 = wellKnownSymbol("iterator"),
    BUGGY_SAFARI_ITERATORS$1 = !1,
    returnThis$2 = function returnThis$2() {
  return this;
},
    IteratorPrototype$2,
    PrototypeOfArrayIteratorPrototype,
    arrayIterator;

_keysInstanceProperty([]) && (arrayIterator = _keysInstanceProperty(_context18 = []).call(_context18), "next" in arrayIterator ? (PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator)), PrototypeOfArrayIteratorPrototype !== Object.prototype && (IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype)) : BUGGY_SAFARI_ITERATORS$1 = !0);
var NEW_ITERATOR_PROTOTYPE = null == IteratorPrototype$2 || fails(function () {
  var test = {};
  return IteratorPrototype$2[ITERATOR$4].call(test) !== test;
});
NEW_ITERATOR_PROTOTYPE && (IteratorPrototype$2 = {}), NEW_ITERATOR_PROTOTYPE && !has$1(IteratorPrototype$2, ITERATOR$4) && createNonEnumerableProperty(IteratorPrototype$2, ITERATOR$4, returnThis$2);

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
},
    iterators = {},
    IteratorPrototype$1 = iteratorsCore.IteratorPrototype,
    returnThis$1 = function returnThis$1() {
  return this;
},
    createIteratorConstructor = function createIteratorConstructor(IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + " Iterator";
  return IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
    next: createPropertyDescriptor(1, next)
  }), setToStringTag(IteratorConstructor, TO_STRING_TAG, !1, !0), iterators[TO_STRING_TAG] = returnThis$1, IteratorConstructor;
},
    aPossiblePrototype = function aPossiblePrototype(it) {
  if (!isObject(it) && null !== it) throw TypeError("Can't set " + String(it) + " as a prototype");
  return it;
},
    objectSetPrototypeOf = _Object$setPrototypeOf || ("__proto__" in {} ? function () {
  var setter,
      CORRECT_SETTER = !1,
      test = {};

  try {
    (setter = _Object$getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(test, []), CORRECT_SETTER = test instanceof Array;
  } catch (error) {}

  return function (O, proto) {
    return anObject(O), aPossiblePrototype(proto), CORRECT_SETTER ? setter.call(O, proto) : O.__proto__ = proto, O;
  };
}() : void 0),
    IteratorPrototype = iteratorsCore.IteratorPrototype,
    BUGGY_SAFARI_ITERATORS = iteratorsCore.BUGGY_SAFARI_ITERATORS,
    ITERATOR$3 = wellKnownSymbol("iterator"),
    KEYS = "keys",
    VALUES = "values",
    ENTRIES = "entries",
    returnThis = function returnThis() {
  return this;
},
    defineIterator = function defineIterator(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var CurrentIteratorPrototype,
      methods,
      KEY,
      getIterationMethod = function getIterationMethod(KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS:
      case VALUES:
      case ENTRIES:
        return function () {
          return new IteratorConstructor(this, KIND);
        };
    }

    return function () {
      return new IteratorConstructor(this);
    };
  },
      TO_STRING_TAG = NAME + " Iterator",
      INCORRECT_VALUES_NAME = !1,
      IterablePrototype = Iterable.prototype,
      nativeIterator = IterablePrototype[ITERATOR$3] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT],
      defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT),
      anyNativeIterator = "Array" == NAME && _entriesInstanceProperty(IterablePrototype) || nativeIterator;

  if (anyNativeIterator && (CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable())), IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next && (setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, !0, !0), iterators[TO_STRING_TAG] = returnThis)), DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES && (INCORRECT_VALUES_NAME = !0, defaultIterator = function defaultIterator() {
    return nativeIterator.call(this);
  }), FORCED && IterablePrototype[ITERATOR$3] !== defaultIterator && createNonEnumerableProperty(IterablePrototype, ITERATOR$3, defaultIterator), iterators[NAME] = defaultIterator, DEFAULT) if (methods = {
    values: getIterationMethod(VALUES),
    keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
    entries: getIterationMethod(ENTRIES)
  }, FORCED) for (KEY in methods) {
    (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) && redefine(IterablePrototype, KEY, methods[KEY]);
  } else _export({
    target: NAME,
    proto: !0,
    forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
  }, methods);
  return methods;
},
    charAt = stringMultibyte.charAt,
    STRING_ITERATOR = "String Iterator",
    setInternalState$2 = internalState.set,
    getInternalState$2 = internalState.getterFor(STRING_ITERATOR);

defineIterator(String, "String", function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
}, function () {
  var point,
      state = getInternalState$2(this),
      string = state.string,
      index = state.index;
  return index >= string.length ? {
    value: void 0,
    done: !0
  } : (point = charAt(string, index), state.index += point.length, {
    value: point,
    done: !1
  });
});
var ARRAY_ITERATOR = "Array Iterator",
    setInternalState$1 = internalState.set,
    getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR);
defineIterator(Array, "Array", function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated),
    index: 0,
    kind: kind
  });
}, function () {
  var state = getInternalState$1(this),
      target = state.target,
      kind = state.kind,
      index = state.index++;
  return !target || index >= target.length ? (state.target = void 0, {
    value: void 0,
    done: !0
  }) : "keys" == kind ? {
    value: index,
    done: !1
  } : "values" == kind ? {
    value: target[index],
    done: !1
  } : {
    value: [index, target[index]],
    done: !1
  };
}, "values"), iterators.Arguments = iterators.Array;
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
},
    TO_STRING_TAG = wellKnownSymbol("toStringTag");

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME],
      CollectionPrototype = Collection && Collection.prototype;
  CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG && createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME), iterators[COLLECTION_NAME] = iterators.Array;
}

var iterator$2 = wellKnownSymbolWrapped.f("iterator"),
    iterator$1 = iterator$2,
    iterator = iterator$1,
    _typeof_1 = createCommonjsModule$1(function (module) {
  function _typeof(obj) {
    return "function" == typeof symbol && "symbol" == _typeof2(iterator) ? (module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    }, module.exports["default"] = module.exports, module.exports.__esModule = !0) : (module.exports = _typeof = function _typeof(obj) {
      return obj && "function" == typeof symbol && obj.constructor === symbol && obj !== symbol.prototype ? "symbol" : _typeof2(obj);
    }, module.exports["default"] = module.exports, module.exports.__esModule = !0), _typeof(obj);
  }

  module.exports = _typeof, module.exports["default"] = module.exports, module.exports.__esModule = !0;
}),
    _typeof = unwrapExports(_typeof_1),
    classCallCheck = createCommonjsModule$1(function (module) {
  module.exports = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
  }, module.exports["default"] = module.exports, module.exports.__esModule = !0;
}),
    _classCallCheck = unwrapExports(classCallCheck);

_export({
  target: "Object",
  stat: !0,
  forced: !descriptors,
  sham: !descriptors
}, {
  defineProperty: objectDefineProperty.f
});

var defineProperty_1 = createCommonjsModule$1(function (module) {
  var Object = path.Object,
      defineProperty = module.exports = function (it, key, desc) {
    return Object.defineProperty(it, key, desc);
  };

  Object.defineProperty.sham && (defineProperty.sham = !0);
}),
    defineProperty$4 = defineProperty_1,
    defineProperty$3 = defineProperty$4,
    createClass = createCommonjsModule$1(function (module) {
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), defineProperty$3(target, descriptor.key, descriptor);
    }
  }

  module.exports = function (Constructor, protoProps, staticProps) {
    return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
  }, module.exports["default"] = module.exports, module.exports.__esModule = !0;
}),
    _createClass = unwrapExports(createClass),
    arrayMethodIsStrict = function arrayMethodIsStrict(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    method.call(null, argument || function () {
      throw 1;
    }, 1);
  });
},
    $indexOf = _indexOfInstanceProperty(arrayIncludes),
    nativeIndexOf = _indexOfInstanceProperty([]),
    NEGATIVE_ZERO$1 = !!nativeIndexOf && 1 / _indexOfInstanceProperty(_context19 = [1]).call(_context19, 1, -0) < 0,
    STRICT_METHOD$2 = arrayMethodIsStrict("indexOf");

_export({
  target: "Array",
  proto: !0,
  forced: NEGATIVE_ZERO$1 || !STRICT_METHOD$2
}, {
  indexOf: function indexOf(searchElement) {
    return NEGATIVE_ZERO$1 ? nativeIndexOf.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : void 0);
  }
});

var entryVirtual = function entryVirtual(CONSTRUCTOR) {
  return path[CONSTRUCTOR + "Prototype"];
},
    indexOf$2 = _indexOfInstanceProperty(entryVirtual("Array")),
    ArrayPrototype$7 = Array.prototype,
    indexOf_1 = function indexOf_1(it) {
  var own = _indexOfInstanceProperty(it);

  return it === ArrayPrototype$7 || it instanceof Array && own === _indexOfInstanceProperty(ArrayPrototype$7) ? indexOf$2 : own;
},
    indexOf$1 = indexOf_1,
    indexOf = indexOf$1,
    getOwnPropertySymbols$2 = path.Object.getOwnPropertySymbols,
    getOwnPropertySymbols$1 = getOwnPropertySymbols$2,
    getOwnPropertySymbols = getOwnPropertySymbols$1,
    ITERATOR$2 = wellKnownSymbol("iterator"),
    ArrayPrototype$6 = Array.prototype,
    isArrayIteratorMethod = function isArrayIteratorMethod(it) {
  return void 0 !== it && (iterators.Array === it || ArrayPrototype$6[ITERATOR$2] === it);
},
    ITERATOR$1 = wellKnownSymbol("iterator"),
    getIteratorMethod = function getIteratorMethod(it) {
  if (null != it) return it[ITERATOR$1] || it["@@iterator"] || iterators[classof(it)];
},
    iteratorClose = function iteratorClose(iterator) {
  var returnMethod = iterator["return"];
  if (void 0 !== returnMethod) return anObject(returnMethod.call(iterator)).value;
},
    Result = function Result(stopped, result) {
  this.stopped = stopped, this.result = result;
},
    iterate = function iterate(iterable, unboundFunction, options) {
  var iterator,
      iterFn,
      index,
      length,
      result,
      next,
      step,
      that = options && options.that,
      AS_ENTRIES = !(!options || !options.AS_ENTRIES),
      IS_ITERATOR = !(!options || !options.IS_ITERATOR),
      INTERRUPTED = !(!options || !options.INTERRUPTED),
      fn = functionBindContext(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED),
      stop = function stop(condition) {
    return iterator && iteratorClose(iterator), new Result(!0, condition);
  },
      callFn = function callFn(value) {
    return AS_ENTRIES ? (anObject(value), INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1])) : INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) iterator = iterable;else {
    if ("function" != typeof (iterFn = getIteratorMethod(iterable))) throw TypeError("Target is not iterable");

    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        if ((result = callFn(iterable[index])) && result instanceof Result) return result;
      }

      return new Result(!1);
    }

    iterator = iterFn.call(iterable);
  }

  for (next = iterator.next; !(step = next.call(iterator)).done;) {
    try {
      result = callFn(step.value);
    } catch (error) {
      throw iteratorClose(iterator), error;
    }

    if ("object" == _typeof2(result) && result && result instanceof Result) return result;
  }

  return new Result(!1);
},
    $AggregateError = function $AggregateError(errors, message) {
  var that = this;
  if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
  objectSetPrototypeOf && (that = objectSetPrototypeOf(new Error(void 0), objectGetPrototypeOf(that))), void 0 !== message && createNonEnumerableProperty(that, "message", String(message));
  var errorsArray = [];
  return iterate(errors, errorsArray.push, {
    that: errorsArray
  }), createNonEnumerableProperty(that, "errors", errorsArray), that;
};

$AggregateError.prototype = objectCreate(Error.prototype, {
  constructor: createPropertyDescriptor(5, $AggregateError),
  message: createPropertyDescriptor(5, ""),
  name: createPropertyDescriptor(5, "AggregateError")
}), _export({
  global: !0
}, {
  AggregateError: $AggregateError
});

var nativePromiseConstructor = global_1.Promise,
    redefineAll = function redefineAll(target, src, options) {
  for (var key in src) {
    options && options.unsafe && target[key] ? target[key] = src[key] : redefine(target, key, src[key], options);
  }

  return target;
},
    SPECIES$3 = wellKnownSymbol("species"),
    setSpecies = function setSpecies(CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME),
      defineProperty = objectDefineProperty.f;
  descriptors && Constructor && !Constructor[SPECIES$3] && defineProperty(Constructor, SPECIES$3, {
    configurable: !0,
    get: function get() {
      return this;
    }
  });
},
    anInstance = function anInstance(it, Constructor, name) {
  if (!(it instanceof Constructor)) throw TypeError("Incorrect " + (name ? name + " " : "") + "invocation");
  return it;
},
    ITERATOR = wellKnownSymbol("iterator"),
    SAFE_CLOSING = !1;

try {
  var called = 0,
      iteratorWithReturn = {
    next: function next() {
      return {
        done: !!called++
      };
    },
    "return": function _return() {
      SAFE_CLOSING = !0;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  }, _Array$from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {}

var checkCorrectnessOfIteration = function checkCorrectnessOfIteration(exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return !1;
  var ITERATION_SUPPORT = !1;

  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function next() {
          return {
            done: ITERATION_SUPPORT = !0
          };
        }
      };
    }, exec(object);
  } catch (error) {}

  return ITERATION_SUPPORT;
},
    SPECIES$2 = wellKnownSymbol("species"),
    speciesConstructor = function speciesConstructor(O, defaultConstructor) {
  var S,
      C = anObject(O).constructor;
  return void 0 === C || null == (S = anObject(C)[SPECIES$2]) ? defaultConstructor : aFunction$1(S);
},
    engineIsIos = /(?:iphone|ipod|ipad).*applewebkit/i.test(engineUserAgent),
    engineIsNode = "process" == classofRaw(global_1.process),
    location$1 = global_1.location,
    set = global_1.setImmediate,
    clear = global_1.clearImmediate,
    process$3 = global_1.process,
    MessageChannel = global_1.MessageChannel,
    Dispatch = global_1.Dispatch,
    counter = 0,
    queue = {},
    ONREADYSTATECHANGE = "onreadystatechange",
    defer,
    channel,
    port,
    run = function run(id) {
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id], fn();
  }
},
    runner = function runner(id) {
  return function () {
    run(id);
  };
},
    listener = function listener(event) {
  run(event.data);
},
    post = function post(id) {
  global_1.postMessage(id + "", location$1.protocol + "//" + location$1.host);
};

set && clear || (set = function set(fn) {
  for (var args = [], i = 1; arguments.length > i;) {
    args.push(arguments[i++]);
  }

  return queue[++counter] = function () {
    ("function" == typeof fn ? fn : Function(fn)).apply(void 0, args);
  }, defer(counter), counter;
}, clear = function clear(id) {
  delete queue[id];
}, engineIsNode ? defer = function defer(id) {
  process$3.nextTick(runner(id));
} : Dispatch && Dispatch.now ? defer = function defer(id) {
  Dispatch.now(runner(id));
} : MessageChannel && !engineIsIos ? (channel = new MessageChannel(), port = channel.port2, channel.port1.onmessage = listener, defer = functionBindContext(port.postMessage, port, 1)) : global_1.addEventListener && "function" == typeof postMessage && !global_1.importScripts && location$1 && "file:" !== location$1.protocol && !fails(post) ? (defer = post, global_1.addEventListener("message", listener, !1)) : defer = ONREADYSTATECHANGE in documentCreateElement("script") ? function (id) {
  html.appendChild(documentCreateElement("script"))[ONREADYSTATECHANGE] = function () {
    html.removeChild(this), run(id);
  };
} : function (id) {
  _setTimeout(runner(id), 0);
});
var task$1 = {
  set: set,
  clear: clear
},
    engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent),
    getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f,
    macrotask = task$1.set,
    MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver,
    document$2 = global_1.document,
    process$2 = global_1.process,
    Promise$1 = global_1.Promise,
    queueMicrotaskDescriptor = getOwnPropertyDescriptor(global_1, "queueMicrotask"),
    queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value,
    flush,
    head,
    last,
    notify$1,
    toggle,
    node,
    promise$3,
    then;
queueMicrotask || (flush = function flush() {
  var parent, fn;

  for (engineIsNode && (parent = process$2.domain) && parent.exit(); head;) {
    fn = head.fn, head = head.next;

    try {
      fn();
    } catch (error) {
      throw head ? notify$1() : last = void 0, error;
    }
  }

  last = void 0, parent && parent.enter();
}, engineIsIos || engineIsNode || engineIsWebosWebkit || !MutationObserver || !document$2 ? Promise$1 && Promise$1.resolve ? (promise$3 = Promise$1.resolve(void 0), promise$3.constructor = Promise$1, then = promise$3.then, notify$1 = function notify$1() {
  then.call(promise$3, flush);
}) : notify$1 = engineIsNode ? function () {
  process$2.nextTick(flush);
} : function () {
  macrotask.call(global_1, flush);
} : (toggle = !0, node = document$2.createTextNode(""), new MutationObserver(flush).observe(node, {
  characterData: !0
}), notify$1 = function notify$1() {
  node.data = toggle = !toggle;
}));

var microtask = queueMicrotask || function (fn) {
  var task = {
    fn: fn,
    next: void 0
  };
  last && (last.next = task), head || (head = task, notify$1()), last = task;
},
    PromiseCapability = function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (void 0 !== resolve || void 0 !== reject) throw TypeError("Bad Promise constructor");
    resolve = $$resolve, reject = $$reject;
  }), this.resolve = aFunction$1(resolve), this.reject = aFunction$1(reject);
},
    f = function f(C) {
  return new PromiseCapability(C);
},
    newPromiseCapability$1 = {
  f: f
},
    promiseResolve = function promiseResolve(C, x) {
  if (anObject(C), isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  return (0, promiseCapability.resolve)(x), promiseCapability.promise;
},
    hostReportErrors = function hostReportErrors(a, b) {
  var console = global_1.console;
  console && console.error && (1 === arguments.length ? console.error(a) : console.error(a, b));
},
    perform = function perform(exec) {
  try {
    return {
      error: !1,
      value: exec()
    };
  } catch (error) {
    return {
      error: !0,
      value: error
    };
  }
},
    engineIsBrowser = "object" == (typeof window === "undefined" ? "undefined" : _typeof2(window)),
    task = task$1.set,
    SPECIES$1 = wellKnownSymbol("species"),
    PROMISE = "Promise",
    getInternalState = internalState.get,
    setInternalState = internalState.set,
    getInternalPromiseState = internalState.getterFor(PROMISE),
    NativePromisePrototype = nativePromiseConstructor && nativePromiseConstructor.prototype,
    _PromiseConstructor = nativePromiseConstructor,
    PromiseConstructorPrototype = NativePromisePrototype,
    TypeError$1 = global_1.TypeError,
    document$1 = global_1.document,
    process$1 = global_1.process,
    newPromiseCapability = newPromiseCapability$1.f,
    newGenericPromiseCapability = newPromiseCapability,
    DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global_1.dispatchEvent),
    NATIVE_REJECTION_EVENT = "function" == typeof PromiseRejectionEvent,
    UNHANDLED_REJECTION = "unhandledrejection",
    REJECTION_HANDLED = "rejectionhandled",
    PENDING = 0,
    FULFILLED = 1,
    REJECTED = 2,
    HANDLED = 1,
    UNHANDLED = 2,
    SUBCLASSING = !1,
    Internal,
    OwnPromiseCapability,
    PromiseWrapper,
    FORCED$2 = isForced_1(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(_PromiseConstructor),
      GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(_PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE && 66 === engineV8Version) return !0;
  if (!PromiseConstructorPrototype["finally"]) return !0;
  if (engineV8Version >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return !1;

  var promise = new _PromiseConstructor(function (resolve) {
    resolve(1);
  }),
      FakePromise = function FakePromise(exec) {
    exec(function () {}, function () {});
  };

  return (promise.constructor = {})[SPECIES$1] = FakePromise, !(SUBCLASSING = promise.then(function () {}) instanceof FakePromise) || !GLOBAL_CORE_JS_PROMISE && engineIsBrowser && !NATIVE_REJECTION_EVENT;
}),
    INCORRECT_ITERATION = FORCED$2 || !checkCorrectnessOfIteration(function (iterable) {
  _PromiseConstructor.all(iterable)["catch"](function () {});
}),
    isThenable = function isThenable(it) {
  var then;
  return !(!isObject(it) || "function" != typeof (then = it.then)) && then;
},
    notify = function notify(state, isReject) {
  if (!state.notified) {
    state.notified = !0;
    var chain = state.reactions;
    microtask(function () {
      for (var value = state.value, ok = state.state == FULFILLED, index = 0; chain.length > index;) {
        var result,
            then,
            exited,
            reaction = chain[index++],
            handler = ok ? reaction.ok : reaction.fail,
            resolve = reaction.resolve,
            reject = reaction.reject,
            domain = reaction.domain;

        try {
          handler ? (ok || (state.rejection === UNHANDLED && onHandleUnhandled(state), state.rejection = HANDLED), !0 === handler ? result = value : (domain && domain.enter(), result = handler(value), domain && (domain.exit(), exited = !0)), result === reaction.promise ? reject(TypeError$1("Promise-chain cycle")) : (then = isThenable(result)) ? then.call(result, resolve, reject) : resolve(result)) : reject(value);
        } catch (error) {
          domain && !exited && domain.exit(), reject(error);
        }
      }

      state.reactions = [], state.notified = !1, isReject && !state.rejection && onUnhandled(state);
    });
  }
},
    dispatchEvent = function dispatchEvent(name, promise, reason) {
  var event, handler;
  DISPATCH_EVENT ? ((event = document$1.createEvent("Event")).promise = promise, event.reason = reason, event.initEvent(name, !1, !0), global_1.dispatchEvent(event)) : event = {
    promise: promise,
    reason: reason
  }, !NATIVE_REJECTION_EVENT && (handler = global_1["on" + name]) ? handler(event) : name === UNHANDLED_REJECTION && hostReportErrors("Unhandled promise rejection", reason);
},
    onUnhandled = function onUnhandled(state) {
  task.call(global_1, function () {
    var result,
        promise = state.facade,
        value = state.value;
    if (isUnhandled(state) && (result = perform(function () {
      engineIsNode ? process$1.emit("unhandledRejection", value, promise) : dispatchEvent(UNHANDLED_REJECTION, promise, value);
    }), state.rejection = engineIsNode || isUnhandled(state) ? UNHANDLED : HANDLED, result.error)) throw result.value;
  });
},
    isUnhandled = function isUnhandled(state) {
  return state.rejection !== HANDLED && !state.parent;
},
    onHandleUnhandled = function onHandleUnhandled(state) {
  task.call(global_1, function () {
    var promise = state.facade;
    engineIsNode ? process$1.emit("rejectionHandled", promise) : dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
},
    bind$3 = function bind$3(fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
},
    internalReject = function internalReject(state, value, unwrap) {
  state.done || (state.done = !0, unwrap && (state = unwrap), state.value = value, state.state = REJECTED, notify(state, !0));
},
    internalResolve = function internalResolve(state, value, unwrap) {
  if (!state.done) {
    state.done = !0, unwrap && (state = unwrap);

    try {
      if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
      var then = isThenable(value);
      then ? microtask(function () {
        var wrapper = {
          done: !1
        };

        try {
          then.call(value, bind$3(internalResolve, wrapper, state), bind$3(internalReject, wrapper, state));
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      }) : (state.value = value, state.state = FULFILLED, notify(state, !1));
    } catch (error) {
      internalReject({
        done: !1
      }, error, state);
    }
  }
};

FORCED$2 && (_PromiseConstructor = function PromiseConstructor(executor) {
  anInstance(this, _PromiseConstructor, PROMISE), aFunction$1(executor), Internal.call(this);
  var state = getInternalState(this);

  try {
    executor(bind$3(internalResolve, state), bind$3(internalReject, state));
  } catch (error) {
    internalReject(state, error);
  }
}, PromiseConstructorPrototype = _PromiseConstructor.prototype, Internal = function Internal(executor) {
  setInternalState(this, {
    type: PROMISE,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: [],
    rejection: !1,
    state: PENDING,
    value: void 0
  });
}, Internal.prototype = redefineAll(PromiseConstructorPrototype, {
  then: function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this),
        reaction = newPromiseCapability(speciesConstructor(this, _PromiseConstructor));
    return reaction.ok = "function" != typeof onFulfilled || onFulfilled, reaction.fail = "function" == typeof onRejected && onRejected, reaction.domain = engineIsNode ? process$1.domain : void 0, state.parent = !0, state.reactions.push(reaction), state.state != PENDING && notify(state, !1), reaction.promise;
  },
  "catch": function _catch(onRejected) {
    return this.then(void 0, onRejected);
  }
}), OwnPromiseCapability = function OwnPromiseCapability() {
  var promise = new Internal(),
      state = getInternalState(promise);
  this.promise = promise, this.resolve = bind$3(internalResolve, state), this.reject = bind$3(internalReject, state);
}, newPromiseCapability$1.f = newPromiseCapability = function newPromiseCapability(C) {
  return C === _PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
}), _export({
  global: !0,
  wrap: !0,
  forced: FORCED$2
}, {
  Promise: _PromiseConstructor
}), setToStringTag(_PromiseConstructor, PROMISE, !1, !0), setSpecies(PROMISE), PromiseWrapper = getBuiltIn(PROMISE), _export({
  target: PROMISE,
  stat: !0,
  forced: FORCED$2
}, {
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    return capability.reject.call(void 0, r), capability.promise;
  }
}), _export({
  target: PROMISE,
  stat: !0,
  forced: isPure
}, {
  resolve: function resolve(x) {
    return promiseResolve(this === PromiseWrapper ? _PromiseConstructor : this, x);
  }
}), _export({
  target: PROMISE,
  stat: !0,
  forced: INCORRECT_ITERATION
}, {
  all: function all(iterable) {
    var C = this,
        capability = newPromiseCapability(C),
        resolve = capability.resolve,
        reject = capability.reject,
        result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve),
          values = [],
          counter = 0,
          remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++,
            alreadyCalled = !1;
        values.push(void 0), remaining++, $promiseResolve.call(C, promise).then(function (value) {
          alreadyCalled || (alreadyCalled = !0, values[index] = value, --remaining || resolve(values));
        }, reject);
      }), --remaining || resolve(values);
    });
    return result.error && reject(result.value), capability.promise;
  },
  race: function race(iterable) {
    var C = this,
        capability = newPromiseCapability(C),
        reject = capability.reject,
        result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    return result.error && reject(result.value), capability.promise;
  }
}), _export({
  target: "Promise",
  stat: !0
}, {
  allSettled: function allSettled(iterable) {
    var C = this,
        capability = newPromiseCapability$1.f(C),
        resolve = capability.resolve,
        reject = capability.reject,
        result = perform(function () {
      var promiseResolve = aFunction$1(C.resolve),
          values = [],
          counter = 0,
          remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++,
            alreadyCalled = !1;
        values.push(void 0), remaining++, promiseResolve.call(C, promise).then(function (value) {
          alreadyCalled || (alreadyCalled = !0, values[index] = {
            status: "fulfilled",
            value: value
          }, --remaining || resolve(values));
        }, function (error) {
          alreadyCalled || (alreadyCalled = !0, values[index] = {
            status: "rejected",
            reason: error
          }, --remaining || resolve(values));
        });
      }), --remaining || resolve(values);
    });
    return result.error && reject(result.value), capability.promise;
  }
});
var PROMISE_ANY_ERROR = "No one promise resolved";

_export({
  target: "Promise",
  stat: !0
}, {
  any: function any(iterable) {
    var C = this,
        capability = newPromiseCapability$1.f(C),
        resolve = capability.resolve,
        reject = capability.reject,
        result = perform(function () {
      var promiseResolve = aFunction$1(C.resolve),
          errors = [],
          counter = 0,
          remaining = 1,
          alreadyResolved = !1;
      iterate(iterable, function (promise) {
        var index = counter++,
            alreadyRejected = !1;
        errors.push(void 0), remaining++, promiseResolve.call(C, promise).then(function (value) {
          alreadyRejected || alreadyResolved || (alreadyResolved = !0, resolve(value));
        }, function (error) {
          alreadyRejected || alreadyResolved || (alreadyRejected = !0, errors[index] = error, --remaining || reject(new (getBuiltIn("AggregateError"))(errors, PROMISE_ANY_ERROR)));
        });
      }), --remaining || reject(new (getBuiltIn("AggregateError"))(errors, PROMISE_ANY_ERROR));
    });
    return result.error && reject(result.value), capability.promise;
  }
});

var NON_GENERIC = !!nativePromiseConstructor && fails(function () {
  nativePromiseConstructor.prototype["finally"].call({
    then: function then() {}
  }, function () {});
});

_export({
  target: "Promise",
  proto: !0,
  real: !0,
  forced: NON_GENERIC
}, {
  "finally": function _finally(onFinally) {
    var C = speciesConstructor(this, getBuiltIn("Promise")),
        isFunction = "function" == typeof onFinally;
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
});

var promise$2 = path.Promise,
    promise$1 = promise$2,
    promise = promise$1,
    $assign = _Object$assign,
    defineProperty$2 = _Object$defineProperty,
    objectAssign = !$assign || fails(function () {
  var _context20;

  if (descriptors && 1 !== $assign({
    b: 1
  }, $assign(defineProperty$2({}, "a", {
    enumerable: !0,
    get: function get() {
      defineProperty$2(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), {
    b: 2
  })).b) return !0;

  var A = {},
      B = {},
      symbol = _Symbol();

  return A[symbol] = 7, _forEachInstanceProperty(_context20 = "abcdefghijklmnopqrst".split("")).call(_context20, function (chr) {
    B[chr] = chr;
  }), 7 != $assign({}, A)[symbol] || "abcdefghijklmnopqrst" != objectKeys($assign({}, B)).join("");
}) ? function (target, source) {
  for (var T = toObject(target), argumentsLength = arguments.length, index = 1, getOwnPropertySymbols = objectGetOwnPropertySymbols.f, propertyIsEnumerable = objectPropertyIsEnumerable.f; argumentsLength > index;) {
    for (var key, S = indexedObject(arguments[index++]), keys = getOwnPropertySymbols ? _concatInstanceProperty(_context21 = objectKeys(S)).call(_context21, getOwnPropertySymbols(S)) : objectKeys(S), length = keys.length, j = 0; length > j;) {
      var _context21;

      key = keys[j++], descriptors && !propertyIsEnumerable.call(S, key) || (T[key] = S[key]);
    }
  }

  return T;
} : $assign;

_export({
  target: "Object",
  stat: !0,
  forced: _Object$assign !== objectAssign
}, {
  assign: objectAssign
});

var assign$2 = path.Object.assign,
    assign$1 = assign$2,
    assign = assign$1,
    MATCH$1 = wellKnownSymbol("match"),
    isRegexp = function isRegexp(it) {
  var isRegExp;
  return isObject(it) && (void 0 !== (isRegExp = it[MATCH$1]) ? !!isRegExp : "RegExp" == classofRaw(it));
},
    notARegexp = function notARegexp(it) {
  if (isRegexp(it)) throw TypeError("The method doesn't accept regular expressions");
  return it;
},
    MATCH = wellKnownSymbol("match"),
    correctIsRegexpLogic = function correctIsRegexpLogic(METHOD_NAME) {
  var regexp = /./;

  try {
    "/./"[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      return regexp[MATCH] = !1, "/./"[METHOD_NAME](regexp);
    } catch (error2) {}
  }

  return !1;
},
    $startsWith = _startsWithInstanceProperty(""),
    min$1 = Math.min,
    CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic("startsWith");

_export({
  target: "String",
  proto: !0,
  forced: !CORRECT_IS_REGEXP_LOGIC
}, {
  startsWith: function startsWith(searchString) {
    var that = String(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min$1(arguments.length > 1 ? arguments[1] : void 0, that.length)),
        search = String(searchString);
    return $startsWith ? $startsWith.call(that, search, index) : _sliceInstanceProperty(that).call(that, index, index + search.length) === search;
  }
});

var startsWith$2 = _startsWithInstanceProperty(entryVirtual("String")),
    StringPrototype$1 = String.prototype,
    startsWith_1 = function startsWith_1(it) {
  var own = _startsWithInstanceProperty(it);

  return "string" == typeof it || it === StringPrototype$1 || it instanceof String && own === _startsWithInstanceProperty(StringPrototype$1) ? startsWith$2 : own;
},
    startsWith$1 = startsWith_1,
    startsWith = startsWith$1,
    FAILS_ON_PRIMITIVES = fails(function () {
  objectKeys(1);
});

_export({
  target: "Object",
  stat: !0,
  forced: FAILS_ON_PRIMITIVES
}, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var keys$2 = _keysInstanceProperty(path.Object),
    keys$1 = keys$2,
    keys = keys$1,
    $forEach = _forEachInstanceProperty(arrayIteration),
    STRICT_METHOD$1 = arrayMethodIsStrict("forEach"),
    arrayForEach = STRICT_METHOD$1 ? _forEachInstanceProperty([]) : function (callbackfn) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
};

_export({
  target: "Array",
  proto: !0,
  forced: _forEachInstanceProperty([]) != arrayForEach
}, {
  forEach: arrayForEach
});

var forEach$2 = _forEachInstanceProperty(entryVirtual("Array")),
    forEach$1 = forEach$2,
    ArrayPrototype$5 = Array.prototype,
    DOMIterables = {
  DOMTokenList: !0,
  NodeList: !0
},
    forEach_1 = function forEach_1(it) {
  var own = _forEachInstanceProperty(it);

  return it === ArrayPrototype$5 || it instanceof Array && own === _forEachInstanceProperty(ArrayPrototype$5) || DOMIterables.hasOwnProperty(classof(it)) ? forEach$1 : own;
},
    forEach = forEach_1,
    concat$2 = _concatInstanceProperty(entryVirtual("Array")),
    ArrayPrototype$4 = Array.prototype,
    concat_1 = function concat_1(it) {
  var own = _concatInstanceProperty(it);

  return it === ArrayPrototype$4 || it instanceof Array && own === _concatInstanceProperty(ArrayPrototype$4) ? concat$2 : own;
},
    concat$1 = concat_1,
    concat = concat$1,
    min = Math.min,
    $lastIndexOf = _lastIndexOfInstanceProperty([]),
    NEGATIVE_ZERO = !!$lastIndexOf && 1 / _lastIndexOfInstanceProperty(_context22 = [1]).call(_context22, 1, -0) < 0,
    STRICT_METHOD = arrayMethodIsStrict("lastIndexOf"),
    FORCED$1 = NEGATIVE_ZERO || !STRICT_METHOD,
    arrayLastIndexOf = FORCED$1 ? function (searchElement) {
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this),
      length = toLength(O.length),
      index = length - 1;

  for (arguments.length > 1 && (index = min(index, toInteger(arguments[1]))), index < 0 && (index = length + index); index >= 0; index--) {
    if (index in O && O[index] === searchElement) return index || 0;
  }

  return -1;
} : $lastIndexOf;

_export({
  target: "Array",
  proto: !0,
  forced: arrayLastIndexOf !== _lastIndexOfInstanceProperty([])
}, {
  lastIndexOf: arrayLastIndexOf
});

var lastIndexOf$2 = _lastIndexOfInstanceProperty(entryVirtual("Array")),
    ArrayPrototype$3 = Array.prototype,
    lastIndexOf_1 = function lastIndexOf_1(it) {
  var own = _lastIndexOfInstanceProperty(it);

  return it === ArrayPrototype$3 || it instanceof Array && own === _lastIndexOfInstanceProperty(ArrayPrototype$3) ? lastIndexOf$2 : own;
},
    lastIndexOf$1 = lastIndexOf_1,
    lastIndexOf = lastIndexOf$1,
    $stringify = getBuiltIn("JSON", "stringify"),
    re = /[\uD800-\uDFFF]/g,
    low = /^[\uD800-\uDBFF]$/,
    hi = /^[\uDC00-\uDFFF]$/,
    fix = function fix(match, offset, string) {
  var prev = string.charAt(offset - 1),
      next = string.charAt(offset + 1);
  return low.test(match) && !hi.test(next) || hi.test(match) && !low.test(prev) ? "\\u" + match.charCodeAt(0).toString(16) : match;
},
    FORCED = fails(function () {
  return "\"\\udf06\\ud834\"" !== $stringify("\uDF06\uD834") || "\"\\udead\"" !== $stringify("\uDEAD");
});

$stringify && _export({
  target: "JSON",
  stat: !0,
  forced: FORCED
}, {
  stringify: function stringify(it, replacer, space) {
    var result = $stringify.apply(null, arguments);
    return "string" == typeof result ? result.replace(re, fix) : result;
  }
}), path.JSON || (path.JSON = {
  stringify: _JSON$stringify
});

var stringify$2 = function stringify$2(it, replacer, space) {
  return path.JSON.stringify.apply(null, arguments);
},
    stringify$1 = stringify$2,
    stringify = stringify$1,
    HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport("slice"),
    SPECIES = wellKnownSymbol("species"),
    nativeSlice = _sliceInstanceProperty([]),
    max = Math.max;

_export({
  target: "Array",
  proto: !0,
  forced: !HAS_SPECIES_SUPPORT$1
}, {
  slice: function slice(start, end) {
    var Constructor,
        result,
        n,
        O = toIndexedObject(this),
        length = toLength(O.length),
        k = toAbsoluteIndex(start, length),
        fin = toAbsoluteIndex(void 0 === end ? length : end, length);
    if (isArray$3(O) && ("function" != typeof (Constructor = O.constructor) || Constructor !== Array && !isArray$3(Constructor.prototype) ? isObject(Constructor) && null === (Constructor = Constructor[SPECIES]) && (Constructor = void 0) : Constructor = void 0, Constructor === Array || void 0 === Constructor)) return nativeSlice.call(O, k, fin);

    for (result = new (void 0 === Constructor ? Array : Constructor)(max(fin - k, 0)), n = 0; k < fin; k++, n++) {
      k in O && createProperty(result, n, O[k]);
    }

    return result.length = n, result;
  }
});

var slice$3 = _sliceInstanceProperty(entryVirtual("Array")),
    ArrayPrototype$2 = Array.prototype,
    slice_1 = function slice_1(it) {
  var own = _sliceInstanceProperty(it);

  return it === ArrayPrototype$2 || it instanceof Array && own === _sliceInstanceProperty(ArrayPrototype$2) ? slice$3 : own;
},
    slice$2 = slice_1,
    slice$1 = slice$2,
    slice = _sliceInstanceProperty([]),
    factories = {},
    construct = function construct(C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) {
      list[i] = "a[" + i + "]";
    }

    factories[argsLength] = Function("C,a", "return new C(" + list.join(",") + ")");
  }

  return factories[argsLength](C, args);
},
    functionBind = _bindInstanceProperty(Function) || function (that) {
  var fn = aFunction$1(this),
      partArgs = slice.call(arguments, 1),
      boundFunction = function boundFunction() {
    var args = _concatInstanceProperty(partArgs).call(partArgs, slice.call(arguments));

    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };

  return isObject(fn.prototype) && (boundFunction.prototype = fn.prototype), boundFunction;
};

_export({
  target: "Function",
  proto: !0
}, {
  bind: functionBind
});

var bind$2 = _bindInstanceProperty(entryVirtual("Function")),
    FunctionPrototype = Function.prototype,
    bind_1 = function bind_1(it) {
  var own = _bindInstanceProperty(it);

  return it === FunctionPrototype || it instanceof Function && own === _bindInstanceProperty(FunctionPrototype) ? bind$2 : own;
},
    bind$1 = bind_1,
    bind = bind$1,
    $map = _mapInstanceProperty(arrayIteration),
    HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("map");

_export({
  target: "Array",
  proto: !0,
  forced: !HAS_SPECIES_SUPPORT
}, {
  map: function map(callbackfn) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});

var map$2 = _mapInstanceProperty(entryVirtual("Array")),
    ArrayPrototype$1 = Array.prototype,
    map_1 = function map_1(it) {
  var own = _mapInstanceProperty(it);

  return it === ArrayPrototype$1 || it instanceof Array && own === _mapInstanceProperty(ArrayPrototype$1) ? map$2 : own;
},
    map$1 = map_1,
    map = map$1,
    defineProperty$1 = defineProperty_1,
    defineProperty = defineProperty$1;

_export({
  target: "Array",
  stat: !0
}, {
  isArray: isArray$3
});

var isArray$2 = path.Array.isArray,
    isArray$1 = isArray$2,
    isArray = isArray$1,
    $includes = _includesInstanceProperty(arrayIncludes);

_export({
  target: "Array",
  proto: !0
}, {
  includes: function includes(el) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : void 0);
  }
});

var includes$4 = _includesInstanceProperty(entryVirtual("Array"));

_export({
  target: "String",
  proto: !0,
  forced: !correctIsRegexpLogic("includes")
}, {
  includes: function includes(searchString) {
    var _context23;

    return !!~_indexOfInstanceProperty(_context23 = String(requireObjectCoercible(this))).call(_context23, notARegexp(searchString), arguments.length > 1 ? arguments[1] : void 0);
  }
});

var includes$3 = _includesInstanceProperty(entryVirtual("String")),
    ArrayPrototype = Array.prototype,
    StringPrototype = String.prototype,
    includes$2 = function includes$2(it) {
  var own = _includesInstanceProperty(it);

  return it === ArrayPrototype || it instanceof Array && own === _includesInstanceProperty(ArrayPrototype) ? includes$4 : "string" == typeof it || it === StringPrototype || it instanceof String && own === _includesInstanceProperty(StringPrototype) ? includes$3 : own;
},
    includes$1 = includes$2,
    includes = includes$1,
    _context4,
    _context5;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    Object.prototype.hasOwnProperty.call(s, p) && indexOf(e).call(e, p) < 0 && (t[p] = s[p]);
  }

  if (null != s && "function" == typeof getOwnPropertySymbols) {
    var i = 0;

    for (p = getOwnPropertySymbols(s); i < p.length; i++) {
      indexOf(e).call(e, p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]) && (t[p[i]] = s[p[i]]);
    }
  }

  return t;
}

var Dialog = function () {
  function Dialog() {
    _classCallCheck(this, Dialog), this.initToast();
  }

  return _createClass(Dialog, [{
    key: "initToast",
    value: function value() {
      this.toast = {
        error: function error(msg) {
          console.error("toast:", msg);
        },
        warning: function warning(msg) {
          console.warn("toast:", msg);
        },
        info: function info(msg) {
          console.log("toast:", msg);
        }
      };
    }
  }, {
    key: "modal",
    value: function value(data) {}
  }, {
    key: "update",
    value: function value(attrName, callback) {
      this[attrName] = callback;
    }
  }]), Dialog;
}(),
    dialog = new Dialog(),
    loadJs = function loadJs(url) {
  return new promise(function (resolve) {
    var jsObj = document.createElement("script");
    jsObj.type = "text/javascript", jsObj.async = !0, jsObj.src = url, document.head.appendChild(jsObj), jsObj.onload = function (e) {
      resolve(e);
    };
  });
};

function getEnv() {
  var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      prefix = getEnvObject(null, assign({
    enableUat: !0
  }, options));
  return {
    name: prefix.replace("-", "") || "prod",
    prefix: prefix,
    isTest: "test-" === prefix,
    isUat: "uat-" === prefix,
    isProd: "" === prefix
  };
}

function getEnvObject(isTestOrEnv) {
  var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      prefix = "";
  if ("boolean" == typeof isTestOrEnv) prefix = isTestOrEnv ? "test" : "";else if ("string" == typeof isTestOrEnv) prefix = "prod" === isTestOrEnv ? "" : isTestOrEnv;else {
    var _host = options.host || ("undefined" != typeof location ? location.host : "");

    /^uat[-.]/.test(_host) ? prefix = "uat" : (/^test[-.]/.test(_host) || startsWith(_host).call(_host, "localhost") || /^\d+(\.\d+){3}/.test(_host)) && (prefix = "test");
  }
  return options.enableUat || "uat" !== prefix || (prefix = ""), prefix + (prefix ? "-" : "");
}

function isPlainObject(obj) {
  return "object" == _typeof(obj) && null !== obj;
}

function parseDataToUrl(url, data) {
  var _context,
      _context3,
      dataStr = "";

  return "object" == _typeof(data) && null !== data && keys(data).length > 0 && forEach(_context = keys(data)).call(_context, function (key) {
    var _context2;

    dataStr += concat(_context2 = "".concat(key, "=")).call(_context2, data[key], "&");
  }), "" !== dataStr && (dataStr = dataStr.substr(0, lastIndexOf(dataStr).call(dataStr, "&")), url = concat(_context3 = "".concat(url, "?")).call(_context3, dataStr)), url;
}

function sendPost(url, data) {
  var headers = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return fetch(url, {
    body: isPlainObject(data) ? stringify(data) : data,
    headers: assign({
      "Content-Type": "application/json;charset=utf-8",
      "x-real-bu": "true"
    }, headers),
    method: "POST"
  }).then(function (response) {
    return response.json();
  });
}

function sendGet(url) {
  var data = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      headers = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return fetch(parseDataToUrl(url, data), {
    headers: assign({
      "Content-Type": "application/x-www-form-urlencoded",
      "x-real-bu": "true"
    }, headers),
    method: "GET"
  }).then(function (response) {
    return response.json();
  });
}

var request = {
  post: sendPost,
  get: sendGet
},
    errorCode = {
  41302: {
    popupTip: !0,
    popupTitle: "手机号冻结",
    popupMsg: "您的手机号已被冻结，如有疑问可申诉",
    popupLeftBtnMsg: "取消",
    popupRightBtnMsg: "申诉",
    popupLeftBtnUrl: null,
    popupRightBtnUrl: "https://h5.hibixin.com/bixin/account-appeal/index?needLogin=0#/?type=1"
  },
  41319: {
    popupTip: !0,
    isDynamic: !0,
    popupTitle: "手机号冻结",
    popupMsg: "你的帐号已被永久冻结，如有疑问可申诉",
    popupLeftBtnMsg: "取消",
    popupRightBtnMsg: "申诉",
    popupLeftBtnUrl: null,
    popupRightBtnUrl: "https://h5.hibixin.com/bixin/account-appeal/index?needLogin=0#/?type=1"
  },
  41320: {
    popupTip: !0,
    isDynamic: !0,
    popupTitle: "手机号冻结",
    popupMsg: "你的帐号已被冻结，剩余...天，如有疑问可申诉",
    popupLeftBtnMsg: "取消",
    popupRightBtnMsg: "申诉",
    popupLeftBtnUrl: null,
    popupRightBtnUrl: "https://h5.hibixin.com/bixin/account-appeal/index?needLogin=0#/?type=1"
  },
  41401: {
    popupTip: !0,
    isDynamic: !1,
    popupTitle: "设备冻结",
    popupMsg: "您的设备已被冻结，如有疑问可申诉",
    popupLeftBtnMsg: "取消",
    popupRightBtnMsg: "申诉",
    popupLeftBtnUrl: null,
    popupRightBtnUrl: "https://h5.hibixin.com/pandora/624?needLogin=0"
  },
  41404: {
    popupTip: !0,
    isDynamic: !1,
    popupTitle: "提示",
    popupMsg: "注册失败,如有疑问请查看解决方案",
    popupLeftBtnMsg: "取消",
    popupRightBtnMsg: "查看解决方案",
    popupLeftBtnUrl: null,
    popupRightBtnUrl: "https://h5.hibixin.com/pandora/1236?needLogin=0"
  },
  41405: {
    popupTip: !0,
    isDynamic: !1,
    popupTitle: "提示",
    popupMsg: "登录失败,如有疑问请查看解决方案",
    popupLeftBtnMsg: "取消",
    popupRightBtnMsg: "查看解决方案",
    popupLeftBtnUrl: null,
    popupRightBtnUrl: "https://h5.hibixin.com/pandora/249?needLogin=0"
  },
  41219: {
    popupTip: !0,
    isDynamic: !1,
    popupTitle: "提示",
    popupMsg: "你的帐号已被注销，现登录即重新注册",
    popupLeftBtnMsg: "",
    popupRightBtnMsg: "去注册",
    popupLeftBtnUrl: "",
    popupRightBtnUrl: ""
  }
},
    BUNDLE_ID = {
  bixin: "yitan.com.out.code.app.bixin",
  bixinGame: "node.bixin.gameTeam.h5",
  yuer: "yitan.com.out.code.app.yuer",
  xxq: "yitan.com.out.code.app.xxq",
  tangguo: "yitan.com.out.code.app.tangguo",
  yep: "yitan.com.out.code.app.yep",
  chuke: "yitan.com.out.code.app.chuke",
  mvp: "yitan.com.out.code.app.mvp",
  kgxq: "yitan.com.out.code.app.kgxq",
  tayu: "yitan.com.out.code.app.tayu",
  fantang: "yitan.com.out.code.app.fantang"
},
    GET_WAY_URL = {
  bixin: "https://gateway.hibixin.com",
  bixinGame: "https://gateway.hibixin.com",
  yuer: "https://gateway.bxyuer.com",
  xxq: "https://gateway.xxqapp.cn",
  tangguo: "https://gateway.tangguoapp.cn",
  yep: "https://gateway.bxwula.com",
  chuke: "https://gateway.zhiy.com",
  mvp: "https://gateway.1-xian.cn",
  kgxq: "https://gateway.gxjunxiao.com",
  tayu: "https://gateway.bxyuer.com",
  fantang: "https://gateway.fantangapp.com"
},
    CHANGE_VERIFY_CODE = "41208",
    CHANGE_VERIFY_CODE2 = "41444",
    host = "prod" === getEnv().name ? "" : getEnv().name + ".",
    Api = {
  post: function post(url, params, headers, appName, hideError) {
    var hostUrlWg = "prod" === getEnv().name ? GET_WAY_URL[appName] : "https://".concat(host.replace(".", "-"), "gateway.yupaopao.com");
    return new promise(function (resolve, reject) {
      var newUrl = hostUrlWg + url;
      request.post(newUrl, params, headers).then(function (res) {
        var success = res.success,
            msg = res.msg,
            code = res.code;

        if (!success && (code === CHANGE_VERIFY_CODE || hideError || dialog.toast.error(msg), errorCode[code])) {
          var obj = errorCode[code];
          obj.popupTip && dialog.modal({
            isModal: obj.isDynamic,
            title: obj.popupTitle,
            content: obj.popupMsg,
            okText: obj.popupRightBtnMsg,
            cancelText: obj.popupLeftBtnMsg,
            cancelUrl: obj.popupLeftBtnUrl,
            okUrl: obj.popupRightBtnUrl
          });
        }

        resolve(res);
      })["catch"](function (err) {
        dialog.toast.error(stringify(err)), reject(err);
      });
    });
  }
},
    _sendCode = function _sendCode(p, h, appName, hideError) {
  return Api.post("/passport/verification/code/out/site/send", p, h, appName, hideError);
},
    checkCode = function checkCode(p, h, appName, hideError) {
  return Api.post("/passport/verification/code/out/site/confirm", p, h, appName, hideError);
},
    _login = function _login(p, h, appName, hideError) {
  return Api.post("/passport/out/site/login/code", p, h, appName, hideError);
},
    loginRegister = function loginRegister(p, h, appName, hideError) {
  return Api.post("/passport/out/site/loginRegister/code", p, h, appName, hideError);
},
    registerInfo = function registerInfo(p, h, appName, hideError) {
  return Api.post("/userInfoBizGatewayService/activityCompleteUser", p, h, appName, hideError);
},
    _passwordLogin = function _passwordLogin(p, h, appName, hideError) {
  return Api.post("/passport/out/site/login/code/password", p, h, appName, hideError);
},
    _exitLogin = function _exitLogin(p, h, appName, hideError) {
  return Api.post("/passport/out/site/user/logout", p, h, appName, hideError);
},
    checkLogin = function checkLogin(p, h, appName) {
  return Api.post("/userInfoQueryGatewayService/outside/getUserInfo", p, h, appName, !0);
},
    _nationCodeList = function _nationCodeList(p, h, appName, hideError) {
  return Api.post("/passport/nationCode/outside/v1/list", p, h, appName, hideError);
},
    version = "3.7.2",
    VERSION = version,
    _hasatob = "function" == typeof atob,
    _hasbtoa = "function" == typeof btoa,
    _hasBuffer = "function" == typeof Buffer,
    _TD = "function" == typeof TextDecoder ? new TextDecoder() : void 0,
    _TE = "function" == typeof TextEncoder ? new TextEncoder() : void 0,
    b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    b64chs = slice$1(Array.prototype).call(b64ch),
    b64tab = (tab = {}, forEach(b64chs).call(b64chs, function (c, i) {
  return tab[c] = i;
}), tab),
    b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/,
    _fromCC = bind(_context4 = String.fromCharCode).call(_context4, String),
    _U8Afrom = "function" == typeof Uint8Array.from ? bind(_context5 = Uint8Array.from).call(_context5, Uint8Array) : function (it) {
  var _context6,
      fn = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (x) {
    return x;
  };

  return new Uint8Array(map(_context6 = slice$1(Array.prototype).call(it, 0)).call(_context6, fn));
},
    _mkUriSafe = function _mkUriSafe(src) {
  return src.replace(/=/g, "").replace(/[+\/]/g, function (m0) {
    return "+" == m0 ? "-" : "_";
  });
},
    _tidyB64 = function _tidyB64(s) {
  return s.replace(/[^A-Za-z0-9\+\/]/g, "");
},
    btoaPolyfill = function btoaPolyfill(bin) {
  for (var u32, c0, c1, c2, asc = "", pad = bin.length % 3, i = 0; i < bin.length;) {
    if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
    asc += b64chs[(u32 = c0 << 16 | c1 << 8 | c2) >> 18 & 63] + b64chs[u32 >> 12 & 63] + b64chs[u32 >> 6 & 63] + b64chs[63 & u32];
  }

  return pad ? slice$1(asc).call(asc, 0, pad - 3) + "===".substring(pad) : asc;
},
    _btoa = _hasbtoa ? function (bin) {
  return btoa(bin);
} : _hasBuffer ? function (bin) {
  return Buffer.from(bin, "binary").toString("base64");
} : btoaPolyfill,
    _fromUint8Array = _hasBuffer ? function (u8a) {
  return Buffer.from(u8a).toString("base64");
} : function (u8a) {
  for (var strs = [], i = 0, l = u8a.length; i < l; i += 4096) {
    strs.push(_fromCC.apply(null, u8a.subarray(i, i + 4096)));
  }

  return _btoa(strs.join(""));
},
    fromUint8Array = function fromUint8Array(u8a) {
  var urlsafe = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  return urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
},
    cb_utob = function cb_utob(c) {
  if (c.length < 2) return (cc = c.charCodeAt(0)) < 128 ? c : cc < 2048 ? _fromCC(192 | cc >>> 6) + _fromCC(128 | 63 & cc) : _fromCC(224 | cc >>> 12 & 15) + _fromCC(128 | cc >>> 6 & 63) + _fromCC(128 | 63 & cc);
  var cc = 65536 + 1024 * (c.charCodeAt(0) - 55296) + (c.charCodeAt(1) - 56320);
  return _fromCC(240 | cc >>> 18 & 7) + _fromCC(128 | cc >>> 12 & 63) + _fromCC(128 | cc >>> 6 & 63) + _fromCC(128 | 63 & cc);
},
    re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g,
    utob = function utob(u) {
  return u.replace(re_utob, cb_utob);
},
    _encode = _hasBuffer ? function (s) {
  return Buffer.from(s, "utf8").toString("base64");
} : _TE ? function (s) {
  return _fromUint8Array(_TE.encode(s));
} : function (s) {
  return _btoa(utob(s));
},
    encode = function encode(src) {
  var urlsafe = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  return urlsafe ? _mkUriSafe(_encode(src)) : _encode(src);
},
    encodeURI = function encodeURI(src) {
  return encode(src, !0);
},
    re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g,
    cb_btou = function cb_btou(cccc) {
  switch (cccc.length) {
    case 4:
      var offset = ((7 & cccc.charCodeAt(0)) << 18 | (63 & cccc.charCodeAt(1)) << 12 | (63 & cccc.charCodeAt(2)) << 6 | 63 & cccc.charCodeAt(3)) - 65536;
      return _fromCC(55296 + (offset >>> 10)) + _fromCC(56320 + (1023 & offset));

    case 3:
      return _fromCC((15 & cccc.charCodeAt(0)) << 12 | (63 & cccc.charCodeAt(1)) << 6 | 63 & cccc.charCodeAt(2));

    default:
      return _fromCC((31 & cccc.charCodeAt(0)) << 6 | 63 & cccc.charCodeAt(1));
  }
},
    btou = function btou(b) {
  return b.replace(re_btou, cb_btou);
},
    atobPolyfill = function atobPolyfill(asc) {
  if (asc = asc.replace(/\s+/g, ""), !b64re.test(asc)) throw new TypeError("malformed base64.");
  asc += slice$1("==").call("==", 2 - (3 & asc.length));

  for (var u24, r1, r2, bin = "", i = 0; i < asc.length;) {
    u24 = b64tab[asc.charAt(i++)] << 18 | b64tab[asc.charAt(i++)] << 12 | (r1 = b64tab[asc.charAt(i++)]) << 6 | (r2 = b64tab[asc.charAt(i++)]), bin += 64 === r1 ? _fromCC(u24 >> 16 & 255) : 64 === r2 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, 255 & u24);
  }

  return bin;
},
    _atob = _hasatob ? function (asc) {
  return atob(_tidyB64(asc));
} : _hasBuffer ? function (asc) {
  return Buffer.from(asc, "base64").toString("binary");
} : atobPolyfill,
    _toUint8Array = _hasBuffer ? function (a) {
  return _U8Afrom(Buffer.from(a, "base64"));
} : function (a) {
  return _U8Afrom(_atob(a), function (c) {
    return c.charCodeAt(0);
  });
},
    toUint8Array = function toUint8Array(a) {
  return _toUint8Array(_unURI(a));
},
    _decode = _hasBuffer ? function (a) {
  return Buffer.from(a, "base64").toString("utf8");
} : _TD ? function (a) {
  return _TD.decode(_toUint8Array(a));
} : function (a) {
  return btou(_atob(a));
},
    _unURI = function _unURI(a) {
  return _tidyB64(a.replace(/[-_]/g, function (m0) {
    return "-" == m0 ? "+" : "/";
  }));
},
    decode = function decode(src) {
  return _decode(_unURI(src));
},
    isValid = function isValid(src) {
  if ("string" != typeof src) return !1;
  var s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
},
    _noEnum = function _noEnum(v) {
  return {
    value: v,
    enumerable: !1,
    writable: !0,
    configurable: !0
  };
},
    extendString = function extendString() {
  var _add = function _add(name, body) {
    return defineProperty(String.prototype, name, _noEnum(body));
  };

  _add("fromBase64", function () {
    return decode(this);
  }), _add("toBase64", function (urlsafe) {
    return encode(this, urlsafe);
  }), _add("toBase64URI", function () {
    return encode(this, !0);
  }), _add("toBase64URL", function () {
    return encode(this, !0);
  }), _add("toUint8Array", function () {
    return toUint8Array(this);
  });
},
    extendUint8Array = function extendUint8Array() {
  var _add = function _add(name, body) {
    return defineProperty(Uint8Array.prototype, name, _noEnum(body));
  };

  _add("toBase64", function (urlsafe) {
    return fromUint8Array(this, urlsafe);
  }), _add("toBase64URI", function () {
    return fromUint8Array(this, !0);
  }), _add("toBase64URL", function () {
    return fromUint8Array(this, !0);
  });
},
    extendBuiltins = function extendBuiltins() {
  extendString(), extendUint8Array();
},
    gBase64 = {
  version: version,
  VERSION: VERSION,
  atob: _atob,
  atobPolyfill: atobPolyfill,
  btoa: _btoa,
  btoaPolyfill: btoaPolyfill,
  fromBase64: decode,
  toBase64: encode,
  encode: encode,
  encodeURI: encodeURI,
  encodeURL: encodeURI,
  utob: utob,
  btou: btou,
  decode: decode,
  isValid: isValid,
  fromUint8Array: fromUint8Array,
  toUint8Array: toUint8Array,
  extendString: extendString,
  extendUint8Array: extendUint8Array,
  extendBuiltins: extendBuiltins
},
    tab,
    commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function createCommonjsModule(fn, module) {
  return fn(module = {
    exports: {}
  }, module.exports), module.exports;
}

var md5 = createCommonjsModule(function (module) {
  /**
  * [js-md5]{@link https://github.com/emn178/js-md5}
  *
  * @namespace md5
  * @version 0.7.3
  * @author Chen, Yi-Cyuan [emn178@gmail.com]
  * @copyright Chen, Yi-Cyuan 2014-2017
  * @license MIT
  */
  (function () {
    var ERROR = "input is invalid type",
        WINDOW = "object" == ("undefined" == typeof window ? "undefined" : _typeof(window)),
        root = WINDOW ? window : {};
    root.JS_MD5_NO_WINDOW && (WINDOW = !1);
    var WEB_WORKER = !WINDOW && "object" == ("undefined" == typeof self ? "undefined" : _typeof(self)),
        NODE_JS = !root.JS_MD5_NO_NODE_JS && "object" == ("undefined" == typeof process ? "undefined" : _typeof(process)) && process.versions && process.versions.node;
    NODE_JS ? root = commonjsGlobal : WEB_WORKER && (root = self);
    var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && module.exports,
        ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
        HEX_CHARS = "0123456789abcdef".split(""),
        EXTRA = [128, 32768, 8388608, -2147483648],
        SHIFT = [0, 8, 16, 24],
        OUTPUT_TYPES = ["hex", "array", "digest", "buffer", "arrayBuffer", "base64"],
        BASE64_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""),
        blocks = [],
        buffer8;

    if (ARRAY_BUFFER) {
      var buffer = new ArrayBuffer(68);
      buffer8 = new Uint8Array(buffer), blocks = new Uint32Array(buffer);
    }

    !root.JS_MD5_NO_NODE_JS && isArray || (Array.isArray = function (obj) {
      return "[object Array]" === Object.prototype.toString.call(obj);
    }), !ARRAY_BUFFER || !root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (obj) {
      return "object" == _typeof(obj) && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    });

    var createOutputMethod = function createOutputMethod(outputType) {
      return function (message) {
        return new Md5(!0).update(message)[outputType]();
      };
    },
        createMethod = function createMethod() {
      var method = createOutputMethod("hex");
      NODE_JS && (method = nodeWrap(method)), method.create = function () {
        return new Md5();
      }, method.update = function (message) {
        return method.create().update(message);
      };

      for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
        var type = OUTPUT_TYPES[i];
        method[type] = createOutputMethod(type);
      }

      return method;
    },
        nodeWrap = function nodeWrap(method) {
      var crypto = eval("require('crypto')"),
          Buffer = eval("require('buffer').Buffer"),
          nodeMethod = function nodeMethod(message) {
        if ("string" == typeof message) return crypto.createHash("md5").update(message, "utf8").digest("hex");
        if (null == message) throw ERROR;
        return message.constructor === ArrayBuffer && (message = new Uint8Array(message)), isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer ? crypto.createHash("md5").update(new Buffer(message)).digest("hex") : method(message);
      };

      return nodeMethod;
    };

    function Md5(sharedMemory) {
      if (sharedMemory) blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks, this.buffer8 = buffer8;else if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        this.buffer8 = new Uint8Array(buffer), this.blocks = new Uint32Array(buffer);
      } else this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0;
    }

    Md5.prototype.update = function (message) {
      if (!this.finalized) {
        var notString,
            type = _typeof(message);

        if ("string" !== type) {
          if ("object" !== type) throw ERROR;
          if (null === message) throw ERROR;
          if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);else if (!(isArray(message) || ARRAY_BUFFER && ArrayBuffer.isView(message))) throw ERROR;
          notString = !0;
        }

        for (var code, i, index = 0, length = message.length, blocks = this.blocks, buffer8 = this.buffer8; index < length;) {
          if (this.hashed && (this.hashed = !1, blocks[0] = blocks[16], blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0), notString) {
            if (ARRAY_BUFFER) for (i = this.start; index < length && i < 64; ++index) {
              buffer8[i++] = message[index];
            } else for (i = this.start; index < length && i < 64; ++index) {
              blocks[i >> 2] |= message[index] << SHIFT[3 & i++];
            }
          } else if (ARRAY_BUFFER) for (i = this.start; index < length && i < 64; ++index) {
            (code = message.charCodeAt(index)) < 128 ? buffer8[i++] = code : code < 2048 ? (buffer8[i++] = 192 | code >> 6, buffer8[i++] = 128 | 63 & code) : code < 55296 || code >= 57344 ? (buffer8[i++] = 224 | code >> 12, buffer8[i++] = 128 | code >> 6 & 63, buffer8[i++] = 128 | 63 & code) : (code = 65536 + ((1023 & code) << 10 | 1023 & message.charCodeAt(++index)), buffer8[i++] = 240 | code >> 18, buffer8[i++] = 128 | code >> 12 & 63, buffer8[i++] = 128 | code >> 6 & 63, buffer8[i++] = 128 | 63 & code);
          } else for (i = this.start; index < length && i < 64; ++index) {
            (code = message.charCodeAt(index)) < 128 ? blocks[i >> 2] |= code << SHIFT[3 & i++] : code < 2048 ? (blocks[i >> 2] |= (192 | code >> 6) << SHIFT[3 & i++], blocks[i >> 2] |= (128 | 63 & code) << SHIFT[3 & i++]) : code < 55296 || code >= 57344 ? (blocks[i >> 2] |= (224 | code >> 12) << SHIFT[3 & i++], blocks[i >> 2] |= (128 | code >> 6 & 63) << SHIFT[3 & i++], blocks[i >> 2] |= (128 | 63 & code) << SHIFT[3 & i++]) : (code = 65536 + ((1023 & code) << 10 | 1023 & message.charCodeAt(++index)), blocks[i >> 2] |= (240 | code >> 18) << SHIFT[3 & i++], blocks[i >> 2] |= (128 | code >> 12 & 63) << SHIFT[3 & i++], blocks[i >> 2] |= (128 | code >> 6 & 63) << SHIFT[3 & i++], blocks[i >> 2] |= (128 | 63 & code) << SHIFT[3 & i++]);
          }
          this.lastByteIndex = i, this.bytes += i - this.start, i >= 64 ? (this.start = i - 64, this.hash(), this.hashed = !0) : this.start = i;
        }

        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, Md5.prototype.finalize = function () {
      if (!this.finalized) {
        this.finalized = !0;
        var blocks = this.blocks,
            i = this.lastByteIndex;
        blocks[i >> 2] |= EXTRA[3 & i], i >= 56 && (this.hashed || this.hash(), blocks[0] = blocks[16], blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0), blocks[14] = this.bytes << 3, blocks[15] = this.hBytes << 3 | this.bytes >>> 29, this.hash();
      }
    }, Md5.prototype.hash = function () {
      var a,
          b,
          c,
          d,
          bc,
          da,
          blocks = this.blocks;
      this.first ? b = ((b = ((a = ((a = blocks[0] - 680876937) << 7 | a >>> 25) - 271733879 << 0) ^ (c = ((c = (-271733879 ^ (d = ((d = (-1732584194 ^ 2004318071 & a) + blocks[1] - 117830708) << 12 | d >>> 20) + a << 0) & (-271733879 ^ a)) + blocks[2] - 1126478375) << 17 | c >>> 15) + d << 0) & (d ^ a)) + blocks[3] - 1316259209) << 22 | b >>> 10) + c << 0 : (a = this.h0, b = this.h1, c = this.h2, b = ((b += ((a = ((a += ((d = this.h3) ^ b & (c ^ d)) + blocks[0] - 680876936) << 7 | a >>> 25) + b << 0) ^ (c = ((c += (b ^ (d = ((d += (c ^ a & (b ^ c)) + blocks[1] - 389564586) << 12 | d >>> 20) + a << 0) & (a ^ b)) + blocks[2] + 606105819) << 17 | c >>> 15) + d << 0) & (d ^ a)) + blocks[3] - 1044525330) << 22 | b >>> 10) + c << 0), b = ((b += ((a = ((a += (d ^ b & (c ^ d)) + blocks[4] - 176418897) << 7 | a >>> 25) + b << 0) ^ (c = ((c += (b ^ (d = ((d += (c ^ a & (b ^ c)) + blocks[5] + 1200080426) << 12 | d >>> 20) + a << 0) & (a ^ b)) + blocks[6] - 1473231341) << 17 | c >>> 15) + d << 0) & (d ^ a)) + blocks[7] - 45705983) << 22 | b >>> 10) + c << 0, b = ((b += ((a = ((a += (d ^ b & (c ^ d)) + blocks[8] + 1770035416) << 7 | a >>> 25) + b << 0) ^ (c = ((c += (b ^ (d = ((d += (c ^ a & (b ^ c)) + blocks[9] - 1958414417) << 12 | d >>> 20) + a << 0) & (a ^ b)) + blocks[10] - 42063) << 17 | c >>> 15) + d << 0) & (d ^ a)) + blocks[11] - 1990404162) << 22 | b >>> 10) + c << 0, b = ((b += ((a = ((a += (d ^ b & (c ^ d)) + blocks[12] + 1804603682) << 7 | a >>> 25) + b << 0) ^ (c = ((c += (b ^ (d = ((d += (c ^ a & (b ^ c)) + blocks[13] - 40341101) << 12 | d >>> 20) + a << 0) & (a ^ b)) + blocks[14] - 1502002290) << 17 | c >>> 15) + d << 0) & (d ^ a)) + blocks[15] + 1236535329) << 22 | b >>> 10) + c << 0, b = ((b += ((d = ((d += (b ^ c & ((a = ((a += (c ^ d & (b ^ c)) + blocks[1] - 165796510) << 5 | a >>> 27) + b << 0) ^ b)) + blocks[6] - 1069501632) << 9 | d >>> 23) + a << 0) ^ a & ((c = ((c += (a ^ b & (d ^ a)) + blocks[11] + 643717713) << 14 | c >>> 18) + d << 0) ^ d)) + blocks[0] - 373897302) << 20 | b >>> 12) + c << 0, b = ((b += ((d = ((d += (b ^ c & ((a = ((a += (c ^ d & (b ^ c)) + blocks[5] - 701558691) << 5 | a >>> 27) + b << 0) ^ b)) + blocks[10] + 38016083) << 9 | d >>> 23) + a << 0) ^ a & ((c = ((c += (a ^ b & (d ^ a)) + blocks[15] - 660478335) << 14 | c >>> 18) + d << 0) ^ d)) + blocks[4] - 405537848) << 20 | b >>> 12) + c << 0, b = ((b += ((d = ((d += (b ^ c & ((a = ((a += (c ^ d & (b ^ c)) + blocks[9] + 568446438) << 5 | a >>> 27) + b << 0) ^ b)) + blocks[14] - 1019803690) << 9 | d >>> 23) + a << 0) ^ a & ((c = ((c += (a ^ b & (d ^ a)) + blocks[3] - 187363961) << 14 | c >>> 18) + d << 0) ^ d)) + blocks[8] + 1163531501) << 20 | b >>> 12) + c << 0, b = ((b += ((d = ((d += (b ^ c & ((a = ((a += (c ^ d & (b ^ c)) + blocks[13] - 1444681467) << 5 | a >>> 27) + b << 0) ^ b)) + blocks[2] - 51403784) << 9 | d >>> 23) + a << 0) ^ a & ((c = ((c += (a ^ b & (d ^ a)) + blocks[7] + 1735328473) << 14 | c >>> 18) + d << 0) ^ d)) + blocks[12] - 1926607734) << 20 | b >>> 12) + c << 0, b = ((b += ((da = (d = ((d += ((bc = b ^ c) ^ (a = ((a += (bc ^ d) + blocks[5] - 378558) << 4 | a >>> 28) + b << 0)) + blocks[8] - 2022574463) << 11 | d >>> 21) + a << 0) ^ a) ^ (c = ((c += (da ^ b) + blocks[11] + 1839030562) << 16 | c >>> 16) + d << 0)) + blocks[14] - 35309556) << 23 | b >>> 9) + c << 0, b = ((b += ((da = (d = ((d += ((bc = b ^ c) ^ (a = ((a += (bc ^ d) + blocks[1] - 1530992060) << 4 | a >>> 28) + b << 0)) + blocks[4] + 1272893353) << 11 | d >>> 21) + a << 0) ^ a) ^ (c = ((c += (da ^ b) + blocks[7] - 155497632) << 16 | c >>> 16) + d << 0)) + blocks[10] - 1094730640) << 23 | b >>> 9) + c << 0, b = ((b += ((da = (d = ((d += ((bc = b ^ c) ^ (a = ((a += (bc ^ d) + blocks[13] + 681279174) << 4 | a >>> 28) + b << 0)) + blocks[0] - 358537222) << 11 | d >>> 21) + a << 0) ^ a) ^ (c = ((c += (da ^ b) + blocks[3] - 722521979) << 16 | c >>> 16) + d << 0)) + blocks[6] + 76029189) << 23 | b >>> 9) + c << 0, b = ((b += ((da = (d = ((d += ((bc = b ^ c) ^ (a = ((a += (bc ^ d) + blocks[9] - 640364487) << 4 | a >>> 28) + b << 0)) + blocks[12] - 421815835) << 11 | d >>> 21) + a << 0) ^ a) ^ (c = ((c += (da ^ b) + blocks[15] + 530742520) << 16 | c >>> 16) + d << 0)) + blocks[2] - 995338651) << 23 | b >>> 9) + c << 0, b = ((b += ((d = ((d += (b ^ ((a = ((a += (c ^ (b | ~d)) + blocks[0] - 198630844) << 6 | a >>> 26) + b << 0) | ~c)) + blocks[7] + 1126891415) << 10 | d >>> 22) + a << 0) ^ ((c = ((c += (a ^ (d | ~b)) + blocks[14] - 1416354905) << 15 | c >>> 17) + d << 0) | ~a)) + blocks[5] - 57434055) << 21 | b >>> 11) + c << 0, b = ((b += ((d = ((d += (b ^ ((a = ((a += (c ^ (b | ~d)) + blocks[12] + 1700485571) << 6 | a >>> 26) + b << 0) | ~c)) + blocks[3] - 1894986606) << 10 | d >>> 22) + a << 0) ^ ((c = ((c += (a ^ (d | ~b)) + blocks[10] - 1051523) << 15 | c >>> 17) + d << 0) | ~a)) + blocks[1] - 2054922799) << 21 | b >>> 11) + c << 0, b = ((b += ((d = ((d += (b ^ ((a = ((a += (c ^ (b | ~d)) + blocks[8] + 1873313359) << 6 | a >>> 26) + b << 0) | ~c)) + blocks[15] - 30611744) << 10 | d >>> 22) + a << 0) ^ ((c = ((c += (a ^ (d | ~b)) + blocks[6] - 1560198380) << 15 | c >>> 17) + d << 0) | ~a)) + blocks[13] + 1309151649) << 21 | b >>> 11) + c << 0, b = ((b += ((d = ((d += (b ^ ((a = ((a += (c ^ (b | ~d)) + blocks[4] - 145523070) << 6 | a >>> 26) + b << 0) | ~c)) + blocks[11] - 1120210379) << 10 | d >>> 22) + a << 0) ^ ((c = ((c += (a ^ (d | ~b)) + blocks[2] + 718787259) << 15 | c >>> 17) + d << 0) | ~a)) + blocks[9] - 343485551) << 21 | b >>> 11) + c << 0, this.first ? (this.h0 = a + 1732584193 << 0, this.h1 = b - 271733879 << 0, this.h2 = c - 1732584194 << 0, this.h3 = d + 271733878 << 0, this.first = !1) : (this.h0 = this.h0 + a << 0, this.h1 = this.h1 + b << 0, this.h2 = this.h2 + c << 0, this.h3 = this.h3 + d << 0);
    }, Md5.prototype.hex = function () {
      this.finalize();
      var h0 = this.h0,
          h1 = this.h1,
          h2 = this.h2,
          h3 = this.h3;
      return HEX_CHARS[h0 >> 4 & 15] + HEX_CHARS[15 & h0] + HEX_CHARS[h0 >> 12 & 15] + HEX_CHARS[h0 >> 8 & 15] + HEX_CHARS[h0 >> 20 & 15] + HEX_CHARS[h0 >> 16 & 15] + HEX_CHARS[h0 >> 28 & 15] + HEX_CHARS[h0 >> 24 & 15] + HEX_CHARS[h1 >> 4 & 15] + HEX_CHARS[15 & h1] + HEX_CHARS[h1 >> 12 & 15] + HEX_CHARS[h1 >> 8 & 15] + HEX_CHARS[h1 >> 20 & 15] + HEX_CHARS[h1 >> 16 & 15] + HEX_CHARS[h1 >> 28 & 15] + HEX_CHARS[h1 >> 24 & 15] + HEX_CHARS[h2 >> 4 & 15] + HEX_CHARS[15 & h2] + HEX_CHARS[h2 >> 12 & 15] + HEX_CHARS[h2 >> 8 & 15] + HEX_CHARS[h2 >> 20 & 15] + HEX_CHARS[h2 >> 16 & 15] + HEX_CHARS[h2 >> 28 & 15] + HEX_CHARS[h2 >> 24 & 15] + HEX_CHARS[h3 >> 4 & 15] + HEX_CHARS[15 & h3] + HEX_CHARS[h3 >> 12 & 15] + HEX_CHARS[h3 >> 8 & 15] + HEX_CHARS[h3 >> 20 & 15] + HEX_CHARS[h3 >> 16 & 15] + HEX_CHARS[h3 >> 28 & 15] + HEX_CHARS[h3 >> 24 & 15];
    }, Md5.prototype.toString = Md5.prototype.hex, Md5.prototype.digest = function () {
      this.finalize();
      var h0 = this.h0,
          h1 = this.h1,
          h2 = this.h2,
          h3 = this.h3;
      return [255 & h0, h0 >> 8 & 255, h0 >> 16 & 255, h0 >> 24 & 255, 255 & h1, h1 >> 8 & 255, h1 >> 16 & 255, h1 >> 24 & 255, 255 & h2, h2 >> 8 & 255, h2 >> 16 & 255, h2 >> 24 & 255, 255 & h3, h3 >> 8 & 255, h3 >> 16 & 255, h3 >> 24 & 255];
    }, Md5.prototype.array = Md5.prototype.digest, Md5.prototype.arrayBuffer = function () {
      this.finalize();
      var buffer = new ArrayBuffer(16),
          blocks = new Uint32Array(buffer);
      return blocks[0] = this.h0, blocks[1] = this.h1, blocks[2] = this.h2, blocks[3] = this.h3, buffer;
    }, Md5.prototype.buffer = Md5.prototype.arrayBuffer, Md5.prototype.base64 = function () {
      for (var v1, v2, v3, base64Str = "", bytes = this.array(), i = 0; i < 15;) {
        v1 = bytes[i++], v2 = bytes[i++], v3 = bytes[i++], base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[63 & (v1 << 4 | v2 >>> 4)] + BASE64_ENCODE_CHAR[63 & (v2 << 2 | v3 >>> 6)] + BASE64_ENCODE_CHAR[63 & v3];
      }

      return v1 = bytes[i], base64Str + (BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[v1 << 4 & 63] + "==");
    };
    var exports = createMethod();
    COMMON_JS ? module.exports = exports : root.md5 = exports;
  })();
}),
    SM = function () {
  function SM() {
    var _this = this;

    _classCallCheck(this, SM), this._appVersion = "0.0.1", this.checkCode = function () {
      var _a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          _a$hideError = _a.hideError,
          hideError = void 0 !== _a$hideError && _a$hideError,
          params = __rest(_a, ["hideError"]);

      return params.mobile && (params.mobile = gBase64.encode(params.mobile)), checkCode(params, _this.WgHeaderParams, _this.appName, hideError);
    }, this.SMParams = {
      organization: "sdj8X1y4Unvsx2DYN3BU",
      product: "popup",
      width: "300px",
      onError: this.onRequestError
    }, this.sendCodeParams = {
      nationCode: "86",
      mobile: "",
      type: "out_site_login",
      sendMode: "1"
    }, this.loginParams = {
      nationCode: "86",
      mobile: "",
      type: "out_site_login"
    }, this.reqHeaderParams = {}, this.WgHeaderParams = {};
  }

  return _createClass(SM, [{
    key: "init",
    value: function value(app, params) {
      var _this2 = this;

      assign(this.SMParams, params), this.appName = app || "bixin", loadJs("".concat(location.protocol, "//castatic.fengkongcloud.com/pr/v1.0.3/smcp.min.js")), loadJs("".concat(location.protocol, "//static.portal101.cn/fpv2.js")).then(function (e) {
        _this2.udid = window.SMSdk.getDeviceId(), _this2.getUdid && _this2.getUdid(_this2.udid);
      });
    }
  }, {
    key: "setReqHeader",
    value: function value(reqHeaderParams) {
      if (assign(this.reqHeaderParams, reqHeaderParams), assign(this.WgHeaderParams, reqHeaderParams), (null == reqHeaderParams ? void 0 : reqHeaderParams.riskScenes) || (null == reqHeaderParams ? void 0 : reqHeaderParams["risk-scenes"])) {
        var scenes = (null == reqHeaderParams ? void 0 : reqHeaderParams.riskScenes) || (null == reqHeaderParams ? void 0 : reqHeaderParams["risk-scenes"]);
        this.loginParams.ext = {
          riskScenes: scenes
        }, this.sendCodeParams.ext = {
          riskScenes: scenes
        };
      }
    }
  }, {
    key: "setLoginType",
    value: function value(type) {
      this.loginType = type;
    }
  }, {
    key: "setAppVersion",
    value: function value(v) {
      this.appVersion = v;
    }
  }, {
    key: "getXUA",
    value: function value(notOnlyXua) {
      var _context8,
          _context9,
          _context10,
          _context11,
          ua = this.parseUa(),
          sys = ua.plat,
          sysV = ua.version,
          webkit = ua.webkitV,
          xua = concat(_context8 = concat(_context9 = concat(_context10 = concat(_context11 = "mapi/1.0 (".concat(sys, " ")).call(_context11, sysV, ";")).call(_context10, BUNDLE_ID[this._appName], " ")).call(_context9, this.appVersion, "; ; ) kernel/1.0(webkit;")).call(_context8, webkit, ")");

      return notOnlyXua ? {
        xua: xua,
        platform: sys,
        version: sysV,
        bundleId: BUNDLE_ID[this._appName]
      } : xua;
    }
  }, {
    key: "getXUD",
    value: function value(callback) {
      this.getUdid = callback;
    }
  }, {
    key: "initSM",
    value: function value() {
      var _this3 = this;

      window.initSMCaptcha(this.SMParams, function (instance) {
        _this3.instance = instance, instance.onReady(function (res) {
          console.log("smJs is done"), "popup" === _this3.SMParams.product && _this3.instance && _this3.instance.verify();
        }), instance.onSuccess(function (data) {
          console.log("verify success callback"), _this3.successCallback && _this3.successCallback(data), data.pass && (_this3.smRes = data), data.pass ? _sendCode(_this3.sendCodeParams, _this3.WgHeaderParams, _this3.appName).then(function (res) {
            var _this3$handleCodeResp = _this3.handleCodeResponse(res),
                success = _this3$handleCodeResp.success,
                result = _this3$handleCodeResp.result;

            success ? _this3.sendCodeResolve && _this3.sendCodeResolve(result) : _this3.sendCodeReject && _this3.sendCodeReject(res);
          }) : dialog.toast.error("图形验证未通过");
        }), instance.onError(function (err) {
          console.error("verify error callback"), _this3.errorCallback && _this3.errorCallback(err);
        }), instance.onClose(function () {
          console.error("verify close callback"), _this3.closeCallback && _this3.closeCallback();
        });
      });
    }
  }, {
    key: "smResult",
    value: function value() {
      return this.instance ? this.instance.getResult() : {
        pass: !1
      };
    }
  }, {
    key: "sendCode",
    value: function value(mobile, extra, hideError) {
      var _this4 = this;

      return this.sendCodeParams.mobile = gBase64.encode(mobile), extra && ("string" == typeof extra && (this.nationCode = extra), "object" == _typeof(extra) && (this.sendCodeParams = assign(assign({}, this.sendCodeParams), extra))), new promise(function (resolve, reject) {
        _sendCode(_this4.sendCodeParams, _this4.WgHeaderParams, _this4.appName, hideError).then(function (res) {
          var _this4$handleCodeResp = _this4.handleCodeResponse(res),
              success = _this4$handleCodeResp.success,
              result = _this4$handleCodeResp.result;

          success ? resolve(result) : res.code === CHANGE_VERIFY_CODE || res.code === CHANGE_VERIFY_CODE2 ? (_this4.sendCodeResolve = resolve, _this4.sendCodeReject = reject) : reject(res);
        });
      });
    }
  }, {
    key: "parseUa",
    value: function value() {
      var ua = navigator.userAgent,
          kuo = ua.substring(indexOf(ua).call(ua, "(") + 1, indexOf(ua).call(ua, ")")),
          uaArr = ua.split(" "),
          webkitV = "";
      forEach(uaArr).call(uaArr, function (item) {
        var _context12;

        includes(_context12 = item.toLowerCase()).call(_context12, "applewebkit") && (webkitV = item.split("/")[1]);
      });
      var plat = "",
          version = "";

      if (console.log(kuo), includes(kuo).call(kuo, "iPhone")) {
        var arr = kuo.split(" ");
        forEach(arr).call(arr, function (item, index) {
          "OS" === item && "" === version && (version = arr[index + 1]);
        }), plat = "iOS";
      } else if (includes(kuo).call(kuo, "Android") || includes(kuo).call(kuo, "android")) {
        var _arr = kuo.split(" ");

        forEach(_arr).call(_arr, function (item, index) {
          "Android" !== item && "android" !== item || "" !== version || (version = _arr[index + 1].replace(";", ""));
        }), plat = "Android";
      } else if (includes(kuo).call(kuo, "Intel Mac") && "" === version) {
        var _arr2 = kuo.split(" ");

        forEach(_arr2).call(_arr2, function (item, index) {
          "OS" === item && "X" === _arr2[index + 1] && "" === version && (version = _arr2[index + 2].replace(";", ""));
        }), plat = "macOs";
      } else if (includes(kuo).call(kuo, "Windows") && "" === version) {
        var _arr3 = kuo.split(" ");

        forEach(_arr3).call(_arr3, function (item, index) {
          "Windows" === item && "NT" === _arr3[index + 1] && "" === version && (version = _arr3[index + 2].replace(";", ""));
        }), plat = "Windows";
      } else includes(kuo).call(kuo, "Unix") && (plat = "Unix", version = "0.0.0");

      return version && plat && webkitV || (plat = "Android", version = "5.0", webkitV = "537.11"), {
        plat: plat,
        version: version = version.replace(/_/g, "."),
        webkitV: webkitV
      };
    }
  }, {
    key: "handleCodeResponse",
    value: function value(res) {
      var code = res.code,
          ext = res.ext,
          result = res.result,
          success = res.success;

      if (!success && ext && (code === CHANGE_VERIFY_CODE || code === CHANGE_VERIFY_CODE2)) {
        switch (ext.certType) {
          case "100":
            this.SMParams.mode = "slide";
            break;

          case "104":
            this.SMParams.mode = "select";
            break;

          case "106":
            this.SMParams.mode = "icon_select";
            break;

          case "105":
            this.SMParams.mode = "seq_select";
            break;

          case "107":
            this.SMParams.mode = "spatial_select";
        }

        this.initSM();
      }

      return {
        success: success,
        result: result
      };
    }
  }, {
    key: "login",
    value: function value(mobile, code, extra) {
      var _this5 = this;

      if (this.loginType && "out_site_login" !== this.loginType) return dialog.toast.error("登录方法与loginType不匹配"), new promise(function (resolve, reject) {
        resolve({});
      });
      this.loginParams.mobile = gBase64.encode(mobile);
      var params = {
        mobile: this.loginParams.mobile,
        type: this.loginType || "out_site_login",
        nationCode: this.loginParams.nationCode,
        verifyCode: code,
        ext: this.loginParams.ext
      };
      return extra && ("string" == typeof extra && (this.nationCode = extra), "object" == _typeof(extra) && (this.loginParams = assign(assign({}, this.loginParams), extra))), new promise(function (resolve, reject) {
        checkCode(params, _this5.WgHeaderParams, _this5.appName).then(function (res) {
          res && res.success ? (res.ext && (_this5.loginParams.ext = res.ext), _this5.loginParams.authToken = res.result, _login(_this5.loginParams, _this5.WgHeaderParams, _this5.appName).then(function (res) {
            res && res.success ? resolve(res.result) : reject(res);
          })) : reject(res);
        });
      });
    }
  }, {
    key: "loginAndRegister",
    value: function value(mobile, code) {
      var _this6 = this,
          isDefaultRegister = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];

      this.loginParams.mobile = gBase64.encode(mobile);
      var params = {
        mobile: this.loginParams.mobile,
        type: this.loginType || "out_site_register_login",
        nationCode: this.loginParams.nationCode,
        verifyCode: code,
        ext: this.loginParams.ext
      };
      return new promise(function (resolve, reject) {
        checkCode(params, _this6.WgHeaderParams, _this6.appName).then(function (res) {
          if (res && res.success) {
            res.ext && (_this6.loginParams.ext = res.ext), _this6.loginParams.authToken = res.result;
            var loginRegisterParams = assign({}, _this6.loginParams);
            delete loginRegisterParams.type, loginRegister(loginRegisterParams, _this6.WgHeaderParams, _this6.appName).then(function (loginRes) {
              if (loginRes && loginRes.success) if (loginRes.result.userInfoAbsence && isDefaultRegister) {
                var registHeader = assign({}, _this6.WgHeaderParams);
                registHeader["x-accessToken"] = loginRes.result.accessToken, registerInfo({}, registHeader, _this6.appName).then(function (reg) {
                  loginRes && loginRes.success ? (reg.result.uid = reg.result.uidStr, resolve(assign({}, loginRes.result, reg.result))) : reject(loginRes);
                });
              } else loginRes && loginRes.success ? resolve(loginRes.result) : reject(loginRes);
            });
          } else reject(res);
        });
      });
    }
  }, {
    key: "toRegister",
    value: function value(gender, nickname, token) {
      var _this7 = this,
          registerHeader = assign({}, this.WgHeaderParams),
          registerParams = {
        gender: gender,
        nickname: nickname
      };

      return registerHeader["x-accessToken"] = token, new promise(function (resolve, reject) {
        registerInfo(registerParams, registerHeader, _this7.appName).then(function (res) {
          res && res.success ? resolve(res.result) : reject(res);
        });
      });
    }
  }, {
    key: "passwordLogin",
    value: function value(mobile, password, nationCode, riskScenes) {
      var _this8 = this;

      return new promise(function (resolve, reject) {
        var params = {
          nationCode: nationCode || "86",
          mobile: gBase64.encode(mobile),
          password: md5(password)
        };
        riskScenes && (params.ext = {
          riskScenes: riskScenes
        }), _passwordLogin(params, _this8.WgHeaderParams, _this8.appName).then(function (res) {
          res && res.success ? resolve(res.result) : reject(res);
        });
      });
    }
  }, {
    key: "exitLogin",
    value: function value(accessToken) {
      var _this9 = this;

      return new promise(function (resolve, reject) {
        var headers = assign(assign({}, _this9.WgHeaderParams), {
          "X-AccessToken": accessToken
        });

        _exitLogin({}, headers, _this9.appName).then(function (res) {
          res && res.success ? resolve(res.result) : reject(res);
        });
      });
    }
  }, {
    key: "getUser",
    value: function value() {
      var _this10 = this,
          reqHeaders = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

      return new promise(function (resolve, reject) {
        var headers = assign(assign({}, _this10.WgHeaderParams), reqHeaders);
        checkLogin({
          scene: 99
        }, headers, _this10.appName).then(function (res) {
          res && res.success && res.result ? resolve(res.result) : reject(res);
        });
      });
    }
  }, {
    key: "nationCodeList",
    value: function value(hideError) {
      var _this11 = this;

      return new promise(function (resolve, reject) {
        _nationCodeList({}, _this11.WgHeaderParams, _this11.appName, hideError).then(function (res) {
          var success = res.success,
              result = res.result;
          success ? resolve(result) : reject(res);
        });
      });
    }
  }, {
    key: "resetXua",
    value: function value() {
      var _context13,
          _context14,
          _context15,
          _context16,
          ua = this.parseUa(),
          sys = ua.plat,
          sysV = ua.version,
          webkit = ua.webkitV,
          bundleId = BUNDLE_ID[this._appName];

      this.WgHeaderParams["x-user-agent"] = concat(_context13 = concat(_context14 = concat(_context15 = concat(_context16 = "mapi/1.0 (".concat(sys, " ")).call(_context16, sysV, ";")).call(_context15, bundleId, " ")).call(_context14, this.appVersion, "; ; ) kernel/1.0(webkit;")).call(_context13, webkit, ")");
    }
  }, {
    key: "appName",
    get: function get() {
      return this._appName;
    },
    set: function set(res) {
      this._appName = res, this.resetXua();
    }
  }, {
    key: "nationCode",
    get: function get() {
      return this._nationCode;
    },
    set: function set(res) {
      this._nationCode = res, this.sendCodeParams.nationCode = res, this.loginParams.nationCode = res;
    }
  }, {
    key: "udid",
    get: function get() {
      return this._udid;
    },
    set: function set(res) {
      this._udid = res, this.WgHeaderParams["x-udid"] = res;
    }
  }, {
    key: "loginType",
    get: function get() {
      return this._loginType;
    },
    set: function set(res) {
      this._loginType = res, this.loginParams.type = res, this.sendCodeParams.type = res;
    }
  }, {
    key: "appVersion",
    get: function get() {
      return this._appVersion;
    },
    set: function set(v) {
      this._appVersion = v || "0.0.1", this.resetXua();
    }
  }, {
    key: "smRes",
    get: function get() {
      return this._smRes;
    },
    set: function set(res) {
      this._smRes = res, this.sendCodeParams.ext = {
        rid: res.rid
      }, this.loginParams.ext = {
        rid: res.rid
      };
    }
  }, {
    key: "onRequestError",
    value: function value(err) {
      console.log("sm init error", err);
    }
  }, {
    key: "smSuccess",
    value: function value(callback) {
      this.successCallback = callback;
    }
  }, {
    key: "smError",
    value: function value(callback) {
      this.errorCallback = callback;
    }
  }, {
    key: "smOnClose",
    value: function value(callback) {
      this.closeCallback = callback;
    }
  }]), SM;
}(),
    sm = new SM();

var alerts = function alerts(str, msec, noMask) {
  var oMask = document.createElement("div"),
      oWrap = document.createElement("div");
  msec = msec || 3e3, oMask.style.cssText = "width:100%;height:100%;position:fixed;left:0;top:0;z-index:99999;", oWrap.style.cssText = "box-sizing:border-box;min-width:140px;max-width:100%;padding:0 20px;height:50px;line-height:50px;text-align:center;border-radius:5px;background:rgba(0,0,0,0.6);color:#fff;font-size:14px;position:fixed;top:50%;left:50%;z-index:99999;transform:translate3d(-50%,-50%,0);-webkit-transform:translate3d(-50%,0,0);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:opacity 3s ease-in 0s;-webkit-transition:opacity 3s ease-in 0s;opacity:1;", oWrap.innerHTML = str, oWrap.style.transitionDuration = msec / 1e3 / 2 + "s", noMask ? document.body.appendChild(oWrap) : (oMask.appendChild(oWrap), document.body.appendChild(oMask)), _setTimeout(function () {
    oWrap.style.opacity = "0";
  }, msec / 2), _setTimeout(function () {
    noMask ? document.body.removeChild(oWrap) : document.body.removeChild(oMask);
  }, msec);
},
    toast = {
  info: function info(msg) {
    alerts(msg);
  },
  error: function error(msg) {
    alerts(msg);
  },
  warning: function warning(msg) {
    alerts(msg);
  }
},
    modal = function modal(data) {};

dialog.update("toast", toast), dialog.update("modal", modal);
export { dialog, sm };